/* Fellowpick - Theme JS */
(function() {
  'use strict';

  var MOBILE_LANDSCAPE_QUERY = '(hover: none) and (pointer: coarse) and (orientation: landscape) and (max-height: 500px)';
  var MOBILE_LAYOUT_QUERY = '(max-width: 768px), ' + MOBILE_LANDSCAPE_QUERY;
  var COMPACT_MOBILE_LAYOUT_QUERY = '(max-width: 600px), ' + MOBILE_LANDSCAPE_QUERY;

  /* ---------- Fixed header offset ---------- */
  (function() {
    var bar = document.querySelector('.announcement-bar');
    var header = document.querySelector('.site-header');
    var main = document.getElementById('MainContent');
    if (!header || !main) return;
    var touchStartX = null;
    var touchStartY = null;

    function canScrollUp(element) {
      var current = element;

      while (current && current !== document.body && current !== document.documentElement) {
        if (current instanceof HTMLElement) {
          var style = window.getComputedStyle(current);
          var overflowY = style.overflowY;
          var isScrollable = (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') &&
            current.scrollHeight > current.clientHeight;

          if (isScrollable) {
            return current.scrollTop > 0;
          }
        }

        current = current.parentElement;
      }

      return false;
    }

    function updateTop() {
      var barHeight = bar ? bar.offsetHeight : 0;
      var scrollTop = Math.max(window.scrollY || window.pageYOffset || 0, 0);
      header.style.top = Math.max(0, barHeight - scrollTop) + 'px';
      document.documentElement.style.setProperty('--wishlist-toast-top', (header.getBoundingClientRect().bottom + 16) + 'px');
    }

    function shouldBlockTopOverscroll(target) {
      var scrollTop = Math.max(window.scrollY || window.pageYOffset || 0, 0);
      return scrollTop <= 0 && !canScrollUp(target);
    }

    main.style.paddingTop = header.offsetHeight + 'px';
    updateTop();
    window.addEventListener('scroll', updateTop, { passive: true });
    window.addEventListener('wheel', function(event) {
      if (event.deltaY < 0 && shouldBlockTopOverscroll(event.target)) {
        event.preventDefault();
      }
    }, { passive: false });
    window.addEventListener('touchstart', function(event) {
      if (!event.touches.length) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });
    window.addEventListener('touchmove', function(event) {
      if (!event.touches.length || touchStartX === null || touchStartY === null) return;

      var currentX = event.touches[0].clientX;
      var currentY = event.touches[0].clientY;
      var deltaX = currentX - touchStartX;
      var deltaY = currentY - touchStartY;
      var isDownwardPagePull = deltaY > 8 && Math.abs(deltaY) > Math.abs(deltaX);
      if (isDownwardPagePull && shouldBlockTopOverscroll(event.target)) {
        event.preventDefault();
      }
    }, { passive: false });
    window.addEventListener('touchend', function() {
      touchStartX = null;
      touchStartY = null;
    }, { passive: true });
    window.addEventListener('touchcancel', function() {
      touchStartX = null;
      touchStartY = null;
    }, { passive: true });
    window.addEventListener('resize', function() {
      main.style.paddingTop = header.offsetHeight + 'px';
      updateTop();
    });
  })();

  /* ---------- Mobile Menu ---------- */
  const mobileToggle = document.querySelector('.mobile-menu-toggle');
  const headerNav = document.querySelector('.header-nav');
  if (mobileToggle && headerNav) {
    function closeMobileMenu() {
      headerNav.classList.remove('is-open');
      mobileToggle.setAttribute('aria-expanded', 'false');
    }

    function toggleMobileMenu() {
      var shouldOpen = !headerNav.classList.contains('is-open');
      headerNav.classList.toggle('is-open', shouldOpen);
      mobileToggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    }

    mobileToggle.addEventListener('click', function() {
      toggleMobileMenu();
    });

    document.addEventListener('click', function(event) {
      if (!headerNav.classList.contains('is-open')) return;
      if (event.target.closest('.header-nav') || event.target.closest('.mobile-menu-toggle')) return;
      closeMobileMenu();
    });

    window.addEventListener('scroll', function() {
      if (headerNav.classList.contains('is-open')) closeMobileMenu();
    }, { passive: true });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && headerNav.classList.contains('is-open')) closeMobileMenu();
    });
  }

  /* ---------- Nav Dropdowns ---------- */
  function closeAllDropdowns() {
    document.querySelectorAll('.nav-dropdown-wrap.is-open').forEach(function(w) {
      w.classList.remove('is-open');
      w.querySelector('.nav-dropdown__trigger').setAttribute('aria-expanded', 'false');
    });
  }

  document.querySelectorAll('.nav-dropdown-wrap').forEach(function(wrap) {
    var trigger = wrap.querySelector('.nav-dropdown__trigger');
    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = wrap.classList.contains('is-open');
      closeAllDropdowns();
      if (!isOpen) {
        wrap.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.nav-dropdown-wrap')) closeAllDropdowns();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeAllDropdowns();
  });

  /* ---------- Hero Video Toggle ---------- */
  (function() {
    var heroToggles = Array.from(document.querySelectorAll('[data-hero-video-toggle]'));
    if (!heroToggles.length) return;

    function syncHeroToggleState(button, video) {
      var isPaused = video.paused;
      button.classList.toggle('is-paused', isPaused);
      button.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
      button.setAttribute('aria-label', isPaused ? 'Play background video' : 'Pause background video');

      var label = button.querySelector('[data-hero-video-toggle-label]');
      if (label) label.textContent = isPaused ? 'Play video' : 'Pause video';
    }

    heroToggles.forEach(function(button) {
      var hero = button.closest('.hero');
      var video = hero ? hero.querySelector('.hero__video') : null;
      if (!video) return;

      syncHeroToggleState(button, video);

      button.addEventListener('click', function() {
        if (video.paused) {
          video.play().catch(function() {
            syncHeroToggleState(button, video);
          });
        } else {
          video.pause();
        }
      });

      video.addEventListener('play', function() {
        syncHeroToggleState(button, video);
      });

      video.addEventListener('pause', function() {
        syncHeroToggleState(button, video);
      });
    });
  })();

  /* ---------- Back To Top ---------- */
  (function() {
    var backToTopButton = document.querySelector('[data-back-to-top]');
    var mobileBreakpoint = window.matchMedia(COMPACT_MOBILE_LAYOUT_QUERY);
    if (!backToTopButton) return;

    backToTopButton.addEventListener('click', function() {
      if (!mobileBreakpoint.matches) return;

      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  })();

  /* ---------- Mobile Footer Accordion ---------- */
  (function() {
    var mobileBreakpoint = window.matchMedia(COMPACT_MOBILE_LAYOUT_QUERY);
    var accordions = Array.from(document.querySelectorAll('[data-footer-accordion]'));

    if (!accordions.length) return;

    function setAccordionState(accordion, isOpen) {
      accordion.classList.toggle('is-open', isOpen);
      var trigger = accordion.querySelector('.footer-accordion__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    function syncAccordionState() {
      if (!mobileBreakpoint.matches) {
        accordions.forEach(function(accordion) {
          setAccordionState(accordion, true);
        });
        return;
      }

      accordions.forEach(function(accordion) {
        setAccordionState(accordion, false);
      });
    }

    accordions.forEach(function(accordion) {
      var trigger = accordion.querySelector('.footer-accordion__trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function() {
        if (!mobileBreakpoint.matches) return;

        var shouldOpen = !accordion.classList.contains('is-open');
        accordions.forEach(function(item) {
          setAccordionState(item, false);
        });
        setAccordionState(accordion, shouldOpen);
      });
    });

    syncAccordionState();
    if (typeof mobileBreakpoint.addEventListener === 'function') {
      mobileBreakpoint.addEventListener('change', syncAccordionState);
    } else if (typeof mobileBreakpoint.addListener === 'function') {
      mobileBreakpoint.addListener(syncAccordionState);
    }
  })();

  /* ---------- Email Signup Popup ---------- */
  (function() {
    var popup = document.getElementById('EmailSignupPopup');
    var triggers = Array.from(document.querySelectorAll('[data-email-signup-trigger]'));
    if (!popup || !triggers.length) return;

    var activeTrigger = null;
    var statusNode = popup.querySelector('[data-email-signup-status]');
    var signupForm = document.getElementById('EmailSignupPopupForm');

    function shouldRestorePageScroll() {
      return !(
        popup.classList.contains('is-open')
        || document.querySelector('.quick-add-overlay.is-open')
        || document.querySelector('.get-the-look-overlay.is-open')
        || document.querySelector('.cart-drawer.is-open')
        || document.querySelector('.filter-drawer.is-open')
        || document.querySelector('#SearchOverlay.is-open')
      );
    }

    function setTriggerState(isOpen) {
      triggers.forEach(function(trigger) {
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    function isMobilePopupLayout() {
      return window.matchMedia('(max-width: 640px), (hover: none) and (pointer: coarse) and (orientation: landscape) and (max-height: 500px)').matches;
    }

    function openPopup(trigger, options) {
      var settings = options || {};
      activeTrigger = trigger || activeTrigger || triggers[0];
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      setTriggerState(true);
      document.body.style.overflow = 'hidden';

      if (settings.focus !== false) {
        window.setTimeout(function() {
          var successMessage = popup.querySelector('[data-email-signup-success]');
          var firstInput = popup.querySelector('input:not([type="hidden"])');
          var closeButton = popup.querySelector('[data-email-signup-close]');
          if (isMobilePopupLayout() && closeButton) {
            closeButton.focus({ preventScroll: true });
          } else if (successMessage) {
            successMessage.focus();
          } else if (firstInput) {
            firstInput.focus();
          } else if (closeButton) {
            closeButton.focus();
          }
        }, 40);
      }
    }

    function closePopup(options) {
      var settings = options || {};
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      setTriggerState(false);

      if (shouldRestorePageScroll()) document.body.style.overflow = '';

      if (settings.returnFocus !== false && activeTrigger) {
        activeTrigger.focus();
      }
    }

    function getSignupStatusNode() {
      return popup.querySelector('[data-email-signup-status]');
    }

    function renderSignupSuccess() {
      if (!signupForm) return;
      var successTemplate = popup.querySelector('[data-email-signup-success-template]');

      if (successTemplate) {
        signupForm.innerHTML = successTemplate.innerHTML;
      } else {
        signupForm.innerHTML =
          '<div data-email-signup-status="success">' +
            '<div class="email-signup-popup__success" tabindex="-1" data-email-signup-success>' +
              '<span class="email-signup-popup__success-icon" aria-hidden="true">' +
                '<svg viewBox="0 0 24 24" focusable="false">' +
                  '<path d="M9.4 16.6 4.9 12l1.4-1.4 3.1 3.1 8.3-8.3L19.1 7 9.4 16.6z"/>' +
                '</svg>' +
              '</span>' +
              '<h2 class="email-signup-popup__success-title" id="EmailSignupPopupTitle">THANK YOU</h2>' +
              '<p class="email-signup-popup__success-message">You have successfully subscribed to receive updates</p>' +
            '</div>' +
          '</div>';
      }

      var successMessage = signupForm.querySelector('[data-email-signup-success]');
      if (successMessage) successMessage.focus();
    }

    function renderSignupError(message) {
      if (!signupForm) return;
      var existingError = signupForm.querySelector('.email-signup-popup__message--error');
      if (!existingError) {
        var fields = signupForm.querySelector('.email-signup-popup__fields');
        existingError = document.createElement('div');
        existingError.className = 'email-signup-popup__message email-signup-popup__message--error';
        if (fields && fields.parentNode) {
          fields.parentNode.insertBefore(existingError, fields);
        } else {
          signupForm.prepend(existingError);
        }
      }
      existingError.textContent = message;
    }

    function setSignupLoading(isLoading) {
      if (!signupForm) return;
      var submitButton = signupForm.querySelector('[data-email-signup-submit]');
      if (!submitButton) return;

      submitButton.classList.toggle('is-loading', isLoading);
      submitButton.toggleAttribute('aria-busy', isLoading);
      submitButton.disabled = isLoading;
    }

    function submitSignupFormNatively() {
      if (!signupForm) return;
      setSignupLoading(false);

      if (typeof signupForm.requestSubmit === 'function') {
        signupForm.removeEventListener('submit', handleSignupSubmit);
        signupForm.requestSubmit();
        return;
      }

      signupForm.removeEventListener('submit', handleSignupSubmit);
      signupForm.submit();
    }

    function handleSignupSubmit(event) {
      event.preventDefault();

      if (typeof signupForm.checkValidity === 'function' && !signupForm.checkValidity()) {
        signupForm.reportValidity();
        return;
      }

      setSignupLoading(true);

      fetch(signupForm.action, {
        method: 'POST',
        body: new FormData(signupForm),
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function(response) {
          return response.text();
        })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var nextStatusNode = doc.querySelector('#EmailSignupPopupForm [data-email-signup-status]');
          var nextStatus = nextStatusNode ? nextStatusNode.dataset.emailSignupStatus : '';

          if (nextStatus === 'success' || doc.querySelector('#EmailSignupPopupForm [data-email-signup-success]')) {
            setSignupLoading(false);
            renderSignupSuccess();
            return;
          }

          if (nextStatus === 'error' && nextStatusNode && nextStatusNode.innerHTML.trim()) {
            var currentStatusNode = getSignupStatusNode();
            if (currentStatusNode) currentStatusNode.innerHTML = nextStatusNode.innerHTML;
            setSignupLoading(false);
            return;
          }

          submitSignupFormNatively();
        })
        .catch(function() {
          setSignupLoading(false);
          renderSignupError('We could not complete your signup. Please try again in a moment.');
        });
    }

    triggers.forEach(function(trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.addEventListener('click', function(event) {
        event.preventDefault();
        openPopup(trigger);
      });
    });

    if (signupForm) {
      signupForm.addEventListener('submit', handleSignupSubmit);
    }

    popup.addEventListener('click', function(event) {
      var closeButton = event.target.closest('[data-email-signup-close]');
      if (!closeButton) return;
      event.preventDefault();
      closePopup();
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) {
        closePopup();
      }
    });

    var submittedStatus = statusNode ? statusNode.dataset.emailSignupStatus : '';
    if (submittedStatus || window.location.hash === '#EmailSignupPopupForm') {
      openPopup(null);
    }
  })();

  /* ---------- Variant Selector ---------- */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCartCounts(count) {
    document.querySelectorAll('.cart-count').forEach(el => el.textContent = count);
  }

  function announceCartUpdate(message) {
    var el = document.getElementById('CartAnnouncer');
    if (!el) return;
    el.textContent = '';
    setTimeout(function() { el.textContent = message; }, 50);
  }

  var wishlistStrings = {
    save: document.body ? document.body.dataset.wishlistSaveLabel || 'Save' : 'Save',
    saved: document.body ? document.body.dataset.wishlistSavedLabel || 'Saved' : 'Saved',
    remove: document.body ? document.body.dataset.wishlistRemoveLabel || 'Remove' : 'Remove',
    addToBag: document.body ? document.body.dataset.wishlistAddToBagLabel || 'Add to Bag' : 'Add to Bag',
    added: document.body ? document.body.dataset.wishlistAddedLabel || 'Added' : 'Added',
    soldOut: document.body ? document.body.dataset.wishlistSoldOutLabel || 'Sold Out' : 'Sold Out',
    unavailable: document.body ? document.body.dataset.wishlistUnavailableLabel || 'Unavailable' : 'Unavailable',
    variant: document.body ? document.body.dataset.wishlistVariantLabel || 'Variant' : 'Variant',
    size: document.body ? document.body.dataset.wishlistSizeLabel || 'Size' : 'Size',
    selectSize: document.body ? document.body.dataset.wishlistSelectSizeLabel || 'Select size' : 'Select size',
    chooseSize: document.body ? document.body.dataset.wishlistChooseSizeLabel || 'Choose a size' : 'Choose a size',
    countZero: document.body ? document.body.dataset.wishlistCountZeroLabel || '0 items saved' : '0 items saved',
    countOne: document.body ? document.body.dataset.wishlistCountOneLabel || '1 item saved' : '1 item saved',
    countOther: document.body ? document.body.dataset.wishlistCountOtherLabel || '{{ count }} items saved' : '{{ count }} items saved'
  };
  var productStrings = {
    quickAdd: document.body ? document.body.dataset.productQuickAddLabel || 'Quick Add' : 'Quick Add',
    addToCart: document.body ? document.body.dataset.productAddToCartLabel || 'Add to Cart' : 'Add to Cart',
    copyLink: document.body ? document.body.dataset.productCopyLinkLabel || 'Copy Link' : 'Copy Link',
    linkCopied: document.body ? document.body.dataset.productLinkCopiedLabel || 'Link Copied' : 'Link Copied',
    getTheLook: document.body ? document.body.dataset.productGetTheLookLabel || 'Get the Look' : 'Get the Look',
    itemLabelOne: document.body ? document.body.dataset.productItemLabelOne || 'Item' : 'Item',
    itemLabelOther: document.body ? document.body.dataset.productItemLabelOther || 'Items' : 'Items'
  };

  var WISHLIST_STORAGE_KEY = 'fellowpick:wishlist:v1';
  var wishlistSelections = {};
  var wishlistMetadataRequests = {};
  var wishlistProductDataRequests = {};
  var WISHLIST_ADD_SUCCESS_PREVIEW_MS = 450;
  var WISHLIST_ADD_SUCCESS_RESET_MS = 1200;
  var QUICK_ADD_SUCCESS_PREVIEW_MS = 1100;
  var QUICK_ADD_SUCCESS_RESET_MS = 1700;
  var CART_DRAWER_WISHLIST_POPUP_MS = 3200;
  var cartDrawerWishlistPopupTimeout = 0;
  var wishlistPageToastTimeout = 0;

  function parseBoolean(value) {
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function parseJson(value, fallback) {
    if (!value || typeof value !== 'string') return fallback;
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function parseWishlistInt(value) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? null : parsed;
  }

  function normalizeVariantInventoryMeta(rawMeta) {
    if (!rawMeta || typeof rawMeta !== 'object') return null;
    var qty = parseInt(rawMeta.qty, 10);
    return {
      qty: isNaN(qty) ? 0 : qty,
      mgmt: rawMeta.mgmt || null,
      policy: rawMeta.policy || null
    };
  }

  function normalizeWishlistVariants(rawVariants) {
    if (!Array.isArray(rawVariants)) return [];
    return rawVariants.map(function(variant) {
      var inventoryMeta = normalizeVariantInventoryMeta(variant || {});
      return {
        id: parseWishlistInt(variant && variant.id),
        available: !!(variant && variant.available),
        options: Array.isArray(variant && variant.options) ? variant.options.slice() : [],
        price: parseInt(variant && variant.price || '0', 10) || 0,
        compare_at_price: parseInt(variant && variant.compare_at_price || '0', 10) || 0,
        image: variant && variant.image ? String(variant.image) : '',
        qty: inventoryMeta ? inventoryMeta.qty : 0,
        mgmt: inventoryMeta ? inventoryMeta.mgmt : null,
        policy: inventoryMeta ? inventoryMeta.policy : null
      };
    }).filter(function(variant) {
      return !!variant.id;
    });
  }

  function normalizeSelectedOptions(rawOptions) {
    return Array.isArray(rawOptions) ? rawOptions.slice() : [];
  }

  function getWishlistItemKey(item) {
    if (!item) return '';
    if (!item.has_selector_option && !item.has_size_option) {
      return item.product_handle
        ? 'variant:' + item.product_handle + ':' + String(item.variant_id || '')
        : 'variant:' + String(item.variant_id || '');
    }

    var selectedOptions = normalizeSelectedOptions(item.selected_options);
    var keyParts = ['product', item.product_handle || '', 'size'];
    var selectorIndex = item.has_selector_option ? item.selector_option_index : item.size_option_index;
    selectedOptions.forEach(function(optionValue, index) {
      if (index === selectorIndex) return;
      keyParts.push(String(index) + '=' + String(optionValue || ''));
    });
    return keyParts.join('|');
  }

  function normalizeWishlistItem(item) {
    if (!item || typeof item !== 'object') return null;

    var selectedOptions = normalizeSelectedOptions(item.selected_options);
    var variants = normalizeWishlistVariants(item.variants);
    var colorOptionIndex = item.color_option_index;
    if (typeof colorOptionIndex !== 'number') {
      colorOptionIndex = parseWishlistInt(colorOptionIndex);
    }
    var sizeOptionIndex = item.size_option_index;
    if (typeof sizeOptionIndex !== 'number') {
      sizeOptionIndex = parseWishlistInt(sizeOptionIndex);
    }
    var selectorOptionIndex = item.selector_option_index;
    if (typeof selectorOptionIndex !== 'number') {
      selectorOptionIndex = parseWishlistInt(selectorOptionIndex);
    }

    var hasColorOption = parseBoolean(item.has_color_option) && colorOptionIndex !== null;
    var hasSizeOption = parseBoolean(item.has_size_option) && sizeOptionIndex !== null;
    var hasSelectorOption = parseBoolean(item.has_selector_option) && selectorOptionIndex !== null;
    if (!hasSelectorOption && hasSizeOption) {
      hasSelectorOption = true;
      selectorOptionIndex = sizeOptionIndex;
    }
    if (!hasSelectorOption && variants.length) {
      var inferredSelectorIndex = null;
      variants[0].options.forEach(function(optionValue, index) {
        if (inferredSelectorIndex !== null || (hasColorOption && index === colorOptionIndex)) return;
        var firstValue = String(optionValue || '');
        var hasVariation = variants.some(function(variant) {
          return String((variant.options || [])[index] || '') !== firstValue;
        });
        if (hasVariation) {
          inferredSelectorIndex = index;
        }
      });
      if (inferredSelectorIndex !== null) {
        hasSelectorOption = true;
        selectorOptionIndex = inferredSelectorIndex;
      }
    }
    var normalizedIsNew = null;
    if (item.is_new === true || item.is_new === false) {
      normalizedIsNew = item.is_new;
    } else if (item.is_new === 'true' || item.is_new === 'false' || item.is_new === 1 || item.is_new === 0 || item.is_new === '1' || item.is_new === '0') {
      normalizedIsNew = parseBoolean(item.is_new);
    }

    var normalizedItem = {
      product_handle: item.product_handle || '',
      product_url: item.product_url || '',
      variant_id: parseWishlistInt(item.variant_id) || 0,
      product_title: item.product_title || '',
      variant_title: item.variant_title || '',
      price: parseInt(item.price || '0', 10) || 0,
      compare_at_price: parseInt(item.compare_at_price || '0', 10) || 0,
      featured_image: item.featured_image || '',
      color: item.color || '',
      size: item.size || '',
      selected_size: item.selected_size || '',
      selector_option_name: item.selector_option_name || (parseBoolean(item.requires_tournament_fields) ? 'Event' : ''),
      available: parseBoolean(item.available),
      is_new: normalizedIsNew,
      requires_tournament_fields: parseBoolean(item.requires_tournament_fields),
      tournament_player_full_name: item.tournament_player_full_name || '',
      tournament_partner_full_name: item.tournament_partner_full_name || '',
      tournament_partner_email: item.tournament_partner_email || '',
      tournament_dupr: item.tournament_dupr || '',
      timestamp: item.timestamp || Date.now(),
      has_color_option: hasColorOption,
      color_option_index: hasColorOption ? colorOptionIndex : null,
      has_size_option: hasSizeOption,
      size_option_index: hasSizeOption ? sizeOptionIndex : null,
      has_selector_option: hasSelectorOption,
      selector_option_index: hasSelectorOption ? selectorOptionIndex : null,
      selected_options: selectedOptions,
      variants: variants
    };

    if (!normalizedItem.selected_options.length && normalizedItem.variant_id && normalizedItem.variants.length) {
      var matchingVariant = normalizedItem.variants.find(function(variant) {
        return variant.id === normalizedItem.variant_id;
      });
      if (matchingVariant) {
        normalizedItem.selected_options = matchingVariant.options.slice();
      }
    }

    if (normalizedItem.has_selector_option) {
      normalizedItem.size = '';
      if (normalizedItem.selected_options[normalizedItem.selector_option_index]) {
        normalizedItem.selected_options[normalizedItem.selector_option_index] = '';
      }
      normalizedItem.selected_size = '';
    }

    if (normalizedItem.has_color_option && normalizedItem.selected_options[normalizedItem.color_option_index]) {
      normalizedItem.color = normalizedItem.selected_options[normalizedItem.color_option_index];
    }

    normalizedItem.wishlist_key = item.wishlist_key || getWishlistItemKey(normalizedItem);
    return normalizedItem;
  }

  function loadWishlist() {
    try {
      var saved = window.localStorage.getItem(WISHLIST_STORAGE_KEY);
      var items = saved ? JSON.parse(saved) : [];
      if (!Array.isArray(items)) return [];
      return items.map(normalizeWishlistItem).filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(items) {
    window.localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(items));
  }

  function applyWishlistSelections(items) {
    if (!Array.isArray(items)) return [];
    return items.map(function(item) {
      if (!item || !item.wishlist_key) return item;
      if (!Object.prototype.hasOwnProperty.call(wishlistSelections, item.wishlist_key)) return item;
      item.selected_size = wishlistSelections[item.wishlist_key] || '';
      return item;
    });
  }

  function parseProductTags(tags) {
    if (Array.isArray(tags)) return tags;
    if (typeof tags === 'string' && tags.length) {
      return tags.split(',').map(function(tag) {
        return String(tag || '').trim();
      }).filter(Boolean);
    }
    return [];
  }

  function fetchWishlistProductData(productHandle) {
    productHandle = String(productHandle || '');
    if (!productHandle) return Promise.resolve(null);
    if (wishlistProductDataRequests[productHandle]) {
      return wishlistProductDataRequests[productHandle];
    }

    wishlistProductDataRequests[productHandle] = fetch('/products/' + encodeURIComponent(productHandle) + '.js')
      .then(function(response) {
        if (!response.ok) throw new Error('Failed to load product metadata');
        return response.json();
      })
      .catch(function() {
        return null;
      })
      .finally(function() {
        delete wishlistProductDataRequests[productHandle];
      });

    return wishlistProductDataRequests[productHandle];
  }

  function hydrateWishlistMetadata(items) {
    if (!Array.isArray(items) || !items.length) return;

    items.forEach(function(item) {
      if (!item || item.is_new !== null || !item.product_handle || wishlistMetadataRequests[item.product_handle]) return;

      wishlistMetadataRequests[item.product_handle] = true;

      fetchWishlistProductData(item.product_handle)
        .then(function(productData) {
          if (!productData) return;
          var productTags = parseProductTags(productData && productData.tags);
          var isNew = productTags.some(function(tag) {
            return String(tag).toLowerCase() === 'new';
          });

          var savedItems = loadWishlist();
          var hasChanges = false;

          savedItems.forEach(function(savedItem) {
            if (!savedItem || savedItem.product_handle !== item.product_handle) return;
            if (savedItem.is_new === isNew) return;
            savedItem.is_new = isNew;
            hasChanges = true;
          });

          if (!hasChanges) return;
          saveWishlist(savedItems);
          publishWishlistUpdate();
        })
        .catch(function() {})
        .finally(function() {
          delete wishlistMetadataRequests[item.product_handle];
        });
    });
  }

  function hydrateWishlistPricing(items) {
    if (!Array.isArray(items) || !items.length) return;

    items.forEach(function(item) {
      if (!item || !item.product_handle || wishlistMetadataRequests['pricing:' + item.product_handle]) return;

      wishlistMetadataRequests['pricing:' + item.product_handle] = true;

      fetchWishlistProductData(item.product_handle)
        .then(function(productData) {
          if (!productData || !Array.isArray(productData.variants)) return;

          var savedItems = loadWishlist();
          var hasChanges = false;

          savedItems.forEach(function(savedItem) {
            if (!savedItem || savedItem.product_handle !== item.product_handle) return;

            var matchingVariant = productData.variants.find(function(variant) {
              return parseWishlistInt(variant && variant.id) === savedItem.variant_id;
            });

            if (!matchingVariant) return;

            var livePrice = parseInt(matchingVariant.price || '0', 10) || 0;
            var liveCompareAtPrice = parseInt(matchingVariant.compare_at_price || '0', 10) || 0;
            var liveAvailable = !!matchingVariant.available;
            var liveVariantTitle = matchingVariant.public_title || matchingVariant.title || savedItem.variant_title || '';
            var liveFeaturedImage = matchingVariant.featured_image && matchingVariant.featured_image.src
              ? matchingVariant.featured_image.src
              : savedItem.featured_image;

            if (
              savedItem.price !== livePrice ||
              savedItem.compare_at_price !== liveCompareAtPrice ||
              savedItem.available !== liveAvailable ||
              savedItem.variant_title !== liveVariantTitle ||
              savedItem.featured_image !== liveFeaturedImage
            ) {
              savedItem.price = livePrice;
              savedItem.compare_at_price = liveCompareAtPrice;
              savedItem.available = liveAvailable;
              savedItem.variant_title = liveVariantTitle;
              savedItem.featured_image = liveFeaturedImage;
              hasChanges = true;
            }
          });

          if (!hasChanges) return;
          saveWishlist(savedItems);
          publishWishlistUpdate();
        })
        .catch(function() {})
        .finally(function() {
          delete wishlistMetadataRequests['pricing:' + item.product_handle];
        });
    });
  }

  function getWishlistCountLabel(count) {
    if (count === 0) return wishlistStrings.countZero;
    if (count === 1) return wishlistStrings.countOne;
    return wishlistStrings.countOther.replace('{{ count }}', count);
  }

  function getWishlistPageCountLabel(count) {
    if (count === 1) return count + ' Product';
    return count + ' Products';
  }

  function updateWishlistCount(count) {
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el) {
      el.textContent = count;
      el.classList.toggle('is-hidden', count < 1);
    });
    document.querySelectorAll('[data-wishlist-count-label]').forEach(function(el) {
      el.textContent = getWishlistCountLabel(count);
    });
    document.querySelectorAll('[data-wishlist-page-count-label]').forEach(function(el) {
      el.textContent = getWishlistPageCountLabel(count);
    });
  }

  function setHeaderWishlistIndicatorVisible(isVisible) {
    var isWishlistPage = window.location.pathname.replace(/\/+$/, '') === '/pages/wishlist';
    if (isWishlistPage) isVisible = false;
    document.querySelectorAll('[data-header-wishlist-indicator]').forEach(function(el) {
      el.classList.toggle('is-visible', !!isVisible);
    });
  }

  function isWishlistSaved(wishlistKey) {
    wishlistKey = String(wishlistKey || '');
    if (!wishlistKey) return false;
    return loadWishlist().some(function(item) {
      return String(item.wishlist_key) === wishlistKey;
    });
  }

  function setWishlistToggleState(toggle, isSaved) {
    if (!toggle) return;
    toggle.classList.toggle('is-active', isSaved);
    toggle.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    toggle.setAttribute('aria-label', isSaved ? wishlistStrings.saved : wishlistStrings.save);
    toggle.setAttribute('title', isSaved ? wishlistStrings.saved : wishlistStrings.save);
    var label = toggle.querySelector('[data-wishlist-toggle-label]');
    if (label) label.textContent = isSaved ? wishlistStrings.saved : wishlistStrings.save;
  }

  function parseCartItemWishlistData(cartItem) {
    if (!cartItem) return null;

    var variantId = parseInt(cartItem.dataset.variantId, 10);
    if (!variantId) return null;

    return {
      variantId: variantId,
      productHandle: cartItem.dataset.productHandle || '',
      selectedOptions: normalizeSelectedOptions(parseJson(cartItem.dataset.selectedOptions, [])),
      sizeOptionIndex: parseWishlistInt(cartItem.dataset.sizeOptionIndex)
    };
  }

  function setCartWishlistIndicatorState(indicator, isSaved) {
    if (!indicator) return;
    if (indicator.hasAttribute('data-wishlist-toggle')) {
      setWishlistToggleState(indicator, !!isSaved);
      return;
    }
    indicator.classList.toggle('is-active', !!isSaved);
    indicator.setAttribute('aria-label', isSaved ? wishlistStrings.saved : wishlistStrings.save);
    indicator.setAttribute('title', isSaved ? wishlistStrings.saved : wishlistStrings.save);
  }

  function doesWishlistItemMatchCartItem(wishlistItem, cartItemData) {
    if (!wishlistItem || !cartItemData) return false;
    if (wishlistItem.product_handle !== cartItemData.productHandle) return false;

    if (!wishlistItem.has_selector_option && !wishlistItem.has_size_option) {
      return wishlistItem.variant_id === cartItemData.variantId;
    }

    var sizeOptionIndex = wishlistItem.has_selector_option ? wishlistItem.selector_option_index : wishlistItem.size_option_index;
    var wishlistOptions = normalizeSelectedOptions(wishlistItem.selected_options);
    var cartOptions = normalizeSelectedOptions(cartItemData.selectedOptions);

    return wishlistOptions.every(function(optionValue, index) {
      if (index === sizeOptionIndex) return true;
      return String(optionValue || '') === String(cartOptions[index] || '');
    });
  }

  function updateCartWishlistIndicators(items) {
    var wishlistItems = Array.isArray(items) ? items : applyWishlistSelections(loadWishlist());

    document.querySelectorAll('.cart-item [data-cart-wishlist-indicator]').forEach(function(indicator) {
      var cartItem = indicator.closest('.cart-item');
      var cartItemData = parseCartItemWishlistData(cartItem);
      var isSaved = !!cartItemData && wishlistItems.some(function(wishlistItem) {
        return doesWishlistItemMatchCartItem(wishlistItem, cartItemData);
      });
      setCartWishlistIndicatorState(indicator, isSaved);
    });
  }

  function buildWishlistItemFromDataset(dataset) {
    var variantId = parseInt(dataset.wishlistVariantId, 10);
    if (!variantId) return null;

    var sizeOptionIndex = parseWishlistInt(dataset.wishlistSizeOptionIndex);
    var hasSizeOption = parseBoolean(dataset.wishlistHasSizeOption) && sizeOptionIndex !== null;
    var colorOptionIndex = parseWishlistInt(dataset.wishlistColorOptionIndex);
    var hasColorOption = parseBoolean(dataset.wishlistHasColorOption) && colorOptionIndex !== null;
    var selectorOptionIndex = parseWishlistInt(dataset.wishlistSelectorOptionIndex);
    var hasSelectorOption = parseBoolean(dataset.wishlistHasSelectorOption) && selectorOptionIndex !== null;
    var selectedOptions = normalizeSelectedOptions(parseJson(dataset.wishlistSelectedOptions, []));
    if (hasSelectorOption && selectedOptions[selectorOptionIndex]) {
      selectedOptions[selectorOptionIndex] = '';
    } else if (hasSizeOption && selectedOptions[sizeOptionIndex]) {
      selectedOptions[sizeOptionIndex] = '';
    }

    return normalizeWishlistItem({
      product_handle: dataset.wishlistProductHandle || '',
      product_url: dataset.wishlistProductUrl || '',
      variant_id: variantId,
      product_title: dataset.wishlistProductTitle || '',
      variant_title: dataset.wishlistVariantTitle || '',
      price: parseInt(dataset.wishlistPrice || '0', 10) || 0,
      compare_at_price: parseInt(dataset.wishlistCompareAtPrice || '0', 10) || 0,
      featured_image: dataset.wishlistFeaturedImage || '',
      color: dataset.wishlistColor || '',
      size: hasSizeOption ? '' : (dataset.wishlistSize || ''),
      selected_size: '',
      available: parseBoolean(dataset.wishlistAvailable),
      is_new: parseBoolean(dataset.wishlistIsNew),
      requires_tournament_fields: parseBoolean(dataset.wishlistRequiresTournamentFields),
      has_color_option: hasColorOption,
      color_option_index: colorOptionIndex,
      has_size_option: hasSizeOption,
      size_option_index: sizeOptionIndex,
      has_selector_option: hasSelectorOption || hasSizeOption,
      selector_option_index: hasSelectorOption ? selectorOptionIndex : sizeOptionIndex,
      selector_option_name: dataset.wishlistSelectorOptionName || '',
      selected_options: selectedOptions,
      variants: normalizeWishlistVariants(parseJson(dataset.wishlistVariants, [])),
      timestamp: Date.now()
    });
  }

  function publishWishlistUpdate() {
    var items = applyWishlistSelections(loadWishlist());
    hydrateWishlistMetadata(items);
    hydrateWishlistPricing(items);
    updateWishlistCount(items.length);
    refreshWishlistToggles(document, items);
    document.dispatchEvent(new CustomEvent('wishlist:updated', {
      detail: {
        items: items
      }
    }));
  }

  function refreshWishlistToggles(root, items) {
    var scope = root && root.querySelectorAll ? root : document;
    var wishlistItems = Array.isArray(items) ? items : applyWishlistSelections(loadWishlist());

    scope.querySelectorAll('[data-wishlist-toggle]').forEach(function(toggle) {
      var item = buildWishlistItemFromDataset(toggle.dataset);
      var isSaved = item ? wishlistItems.some(function(wishlistItem) {
        return String(wishlistItem.wishlist_key) === String(item.wishlist_key);
      }) : false;
      setWishlistToggleState(toggle, isSaved);
    });
  }

  function addWishlistItem(item) {
    var items = loadWishlist().filter(function(existing) {
      return String(existing.wishlist_key) !== String(item.wishlist_key);
    });
    delete wishlistSelections[item.wishlist_key];
    items.unshift(item);
    saveWishlist(items);
    publishWishlistUpdate();
  }

  function removeWishlistItem(wishlistKey) {
    var removedItem = null;
    var items = loadWishlist().filter(function(item) {
      var isMatch = String(item.wishlist_key) === String(wishlistKey);
      if (isMatch) removedItem = item;
      return !isMatch;
    });
    delete wishlistSelections[wishlistKey];
    saveWishlist(items);
    publishWishlistUpdate();
    return removedItem;
  }

  function toggleWishlistItemFromButton(toggle, options) {
    if (!toggle) return;
    var settings = options || {};
    var item = buildWishlistItemFromDataset(toggle.dataset);
    if (!item) return;
    if (isWishlistSaved(item.wishlist_key)) {
      setHeaderWishlistIndicatorVisible(false);
      lastRemovedWishlistItem = removeWishlistItem(item.wishlist_key);
      if (settings.showCartDrawerPopup) {
        showCartDrawerWishlistPopup('Item removed from your wishlist', { showUndo: !!lastRemovedWishlistItem });
      } else if (settings.showBrowseToast) {
        showBrowseWishlistToast('Item removed from your wishlist', { showUndo: !!lastRemovedWishlistItem });
      } else if (settings.showProductPageToast) {
        showProductPageWishlistToast('Item removed from your wishlist', { showUndo: !!lastRemovedWishlistItem });
      }
    } else {
      addWishlistItem(item);
      setHeaderWishlistIndicatorVisible(true);
      lastRemovedWishlistItem = null;
      if (settings.showCartDrawerPopup) {
        showCartDrawerWishlistPopup('Item added to your wishlist', { showLink: true });
      } else if (settings.showBrowseToast) {
        showBrowseWishlistToast('Item added to your wishlist', { showLink: true });
      } else if (settings.showProductPageToast) {
        showProductPageWishlistToast('Item added to your wishlist', { showLink: true });
      }
    }
  }

  function updateWishlistToggleDataset(toggle, data) {
    if (!toggle || !data) return;
    Object.keys(data).forEach(function(key) {
      toggle.dataset[key] = data[key];
    });
    var item = buildWishlistItemFromDataset(toggle.dataset);
    setWishlistToggleState(toggle, item ? isWishlistSaved(item.wishlist_key) : false);
  }

  function setProductCardQuickAddState(button, label, disabled, isLoading, isSuccess) {
    if (!button) return;
    var resolvedLabel = label || button.dataset.quickAddDefaultLabel || productStrings.quickAdd;
    var labelEl = button.querySelector('[data-quick-add-label]');
    if (labelEl) labelEl.textContent = resolvedLabel;
    button.disabled = !!disabled;
    button.classList.toggle('is-loading', !!isLoading);
    button.classList.toggle('is-success', !!isSuccess);
    button.setAttribute('aria-label', resolvedLabel);
    button.setAttribute('title', resolvedLabel);
  }

  function setQuickAddOverlaySizeState(button, label, isDisabled, isLoading, isSuccess) {
    if (!button) return;
    var resolvedLabel = label || productStrings.addToCart;
    var actionLabel = button.querySelector('[data-quick-add-overlay-size-label]');
    if (actionLabel) actionLabel.textContent = resolvedLabel;
    button.disabled = !!isDisabled;
    button.classList.toggle('is-loading', !!isLoading);
    button.classList.toggle('is-success', !!isSuccess);
    button.setAttribute('aria-label', (button.dataset.sizeValue || '') + ' ' + resolvedLabel);
  }

  function getProductCardQuickAddData(button) {
    if (!button) return null;
    var sizeOptionIndex = parseWishlistInt(button.dataset.quickAddSizeOptionIndex);
    var selectorOptionIndex = parseWishlistInt(button.dataset.quickAddSelectorOptionIndex);
    return {
      variantId: parseWishlistInt(button.dataset.quickAddVariantId),
      available: parseBoolean(button.dataset.quickAddAvailable),
      hasSizeOption: parseBoolean(button.dataset.quickAddHasSizeOption) && sizeOptionIndex !== null,
      sizeOptionIndex: sizeOptionIndex,
      hasSelectorOption: parseBoolean(button.dataset.quickAddHasSelectorOption) && selectorOptionIndex !== null,
      selectorOptionIndex: selectorOptionIndex,
      selectorOptionName: button.dataset.quickAddSelectorOptionName || '',
      requiresTournamentFields: parseBoolean(button.dataset.quickAddRequiresTournamentFields),
      selectedOptions: normalizeSelectedOptions(parseJson(button.dataset.quickAddSelectedOptions, [])),
      variants: normalizeWishlistVariants(parseJson(button.dataset.quickAddVariants, []))
    };
  }

  function getQuickAddSelectionOptionIndex(quickAddData) {
    if (!quickAddData) return null;
    if (quickAddData.hasSizeOption) return quickAddData.sizeOptionIndex;
    if (quickAddData.requiresTournamentFields && quickAddData.hasSelectorOption) return quickAddData.selectorOptionIndex;
    return null;
  }

  function getQuickAddSelectionOptionName(quickAddData) {
    if (!quickAddData) return '';
    if (quickAddData.hasSizeOption) return wishlistStrings.size || 'Size';
    return quickAddData.selectorOptionName || wishlistStrings.variant || 'Variant';
  }

  function getProductCardQuickAddMatchingVariants(button) {
    var quickAddData = getProductCardQuickAddData(button);
    if (!quickAddData || !quickAddData.variants.length) return [];
    var selectionOptionIndex = getQuickAddSelectionOptionIndex(quickAddData);

    return quickAddData.variants.filter(function(variant) {
      return variant.options.every(function(optionValue, index) {
        if (selectionOptionIndex !== null && index === selectionOptionIndex) return true;
        return !quickAddData.selectedOptions[index] || quickAddData.selectedOptions[index] === optionValue;
      });
    });
  }

  function getProductCardQuickAddVariantById(button, variantId) {
    var quickAddData = getProductCardQuickAddData(button);
    if (!quickAddData || !quickAddData.variants.length || !variantId) return null;
    return quickAddData.variants.find(function(variant) {
      return variant.id === variantId;
    }) || null;
  }

  var quickAddOverlay = document.getElementById('QuickAddOverlay');
  var quickAddOverlayTitle = quickAddOverlay ? quickAddOverlay.querySelector('[data-quick-add-overlay-title]') : null;
  var quickAddOverlayProduct = quickAddOverlay ? quickAddOverlay.querySelector('[data-quick-add-overlay-product]') : null;
  var quickAddOverlaySizes = quickAddOverlay ? quickAddOverlay.querySelector('[data-quick-add-overlay-sizes]') : null;
  var quickAddOverlayFields = quickAddOverlay ? quickAddOverlay.querySelector('[data-quick-add-overlay-fields]') : null;
  var quickAddActiveButton = null;
  var getTheLookOverlay = document.getElementById('GetTheLookOverlay');
  var getTheLookOverlayTitle = getTheLookOverlay ? getTheLookOverlay.querySelector('[data-get-the-look-overlay-title]') : null;
  var getTheLookOverlayCount = getTheLookOverlay ? getTheLookOverlay.querySelector('[data-get-the-look-overlay-count]') : null;
  var getTheLookOverlayItems = getTheLookOverlay ? getTheLookOverlay.querySelector('[data-get-the-look-overlay-items]') : null;
  var getTheLookActiveTrigger = null;
  var getTheLookActiveGroup = null;
  var getTheLookSelections = {};

  function shouldRestoreBodyScroll() {
    var searchOverlay = document.getElementById('SearchOverlay');
    var filterDrawer = document.getElementById('FilterDrawer');
    return !(
      quickAddOverlay && quickAddOverlay.classList.contains('is-open')
      || getTheLookOverlay && getTheLookOverlay.classList.contains('is-open')
      || cartDrawer && cartDrawer.classList.contains('is-open')
      || searchOverlay && searchOverlay.classList.contains('is-open')
      || filterDrawer && filterDrawer.classList.contains('is-open')
    );
  }

  function buildQuickAddOverlaySizeButtons(button) {
    if (!quickAddOverlaySizes) return 0;

    var quickAddData = getProductCardQuickAddData(button);
    var matchingVariants = getProductCardQuickAddMatchingVariants(button);
    var selectionOptionIndex = getQuickAddSelectionOptionIndex(quickAddData);
    var renderedSizes = {};
    var quickAddActionLabel = productStrings.addToCart || 'Add to Cart';

    quickAddOverlaySizes.innerHTML = '';
    if (!quickAddData || selectionOptionIndex === null) return 0;

    matchingVariants.forEach(function(variant) {
      var sizeValue = String(variant.options[selectionOptionIndex] || '');
      if (!sizeValue || renderedSizes[sizeValue]) return;
      renderedSizes[sizeValue] = true;

      var sizeRow = document.createElement('div');
      sizeRow.className = 'quick-add-overlay__size' + (variant.available ? '' : ' is-disabled');
      sizeRow.innerHTML =
        '<span class="quick-add-overlay__size-label">' + escapeHtml(sizeValue) + '</span>' +
        (variant.available
          ? '<button type="button" class="quick-add-overlay__size-action" data-quick-add-overlay-size data-size-value="' + escapeHtml(sizeValue) + '" aria-label="' + escapeHtml(sizeValue + ' ' + quickAddActionLabel) + '">' +
              '<span data-quick-add-overlay-size-label>' + escapeHtml(quickAddActionLabel) + '</span>' +
              '<span class="quick-add-overlay__size-action-icon quick-add-overlay__size-action-icon--plus" aria-hidden="true">+</span>' +
              '<span class="quick-add-overlay__size-action-spinner" aria-hidden="true"></span>' +
              '<span class="quick-add-overlay__size-action-icon quick-add-overlay__size-action-icon--check" aria-hidden="true">' +
                '<svg viewBox="0 0 24 24" focusable="false">' +
                  '<path d="M7.5 12.5 10.5 15.5 16.5 9.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' +
                '</svg>' +
              '</span>' +
            '</button>'
          : '<span class="quick-add-overlay__size-action quick-add-overlay__size-action--soldout">' + escapeHtml(wishlistStrings.soldOut) + '</span>');
      quickAddOverlaySizes.appendChild(sizeRow);

      var sizeButton = sizeRow.querySelector('[data-quick-add-overlay-size]');
      if (!sizeButton) return;

      sizeButton.dataset.variantId = variant.id ? String(variant.id) : '';
      sizeButton.dataset.variantQty = String(variant.qty || 0);
      sizeButton.dataset.variantMgmt = variant.mgmt ? String(variant.mgmt) : '';
      sizeButton.dataset.variantPolicy = variant.policy ? String(variant.policy) : '';
    });

    return quickAddOverlaySizes.children.length;
  }

  function renderQuickAddOverlayTournamentFields(button, hasSelectionButtons) {
    if (!quickAddOverlayFields) return;

    var quickAddData = getProductCardQuickAddData(button);
    if (!quickAddData || !quickAddData.requiresTournamentFields) {
      quickAddOverlayFields.innerHTML = '';
      quickAddOverlayFields.hidden = true;
      return;
    }

    quickAddOverlayFields.hidden = false;
    quickAddOverlayFields.innerHTML =
      '<div class="quick-add-overlay__tournament-fields" data-quick-add-tournament-fields>' +
        '<label class="quick-add-overlay__field">' +
          '<span class="quick-add-overlay__field-label">Player Full Name <span class="quick-add-overlay__required" aria-hidden="true">*</span></span>' +
          '<input class="quick-add-overlay__input" type="text" autocomplete="name" data-quick-add-property-input data-quick-add-property-name="Player Full Name" required>' +
        '</label>' +
        '<label class="quick-add-overlay__field">' +
          '<span class="quick-add-overlay__field-label">Your DUPR <span class="quick-add-overlay__required" aria-hidden="true">*</span></span>' +
          '<input class="quick-add-overlay__input" type="text" placeholder="3.0 (NR if you don\'t have one)" data-quick-add-property-input data-quick-add-property-name="Your DUPR" required>' +
        '</label>' +
        '<label class="quick-add-overlay__field">' +
          '<span class="quick-add-overlay__field-label">Partner Full Name <span class="quick-add-overlay__required" aria-hidden="true">*</span></span>' +
          '<input class="quick-add-overlay__input" type="text" autocomplete="name" data-quick-add-property-input data-quick-add-property-name="Partner Full Name" required>' +
        '</label>' +
        '<label class="quick-add-overlay__field">' +
          '<span class="quick-add-overlay__field-label">Partner Email <span class="quick-add-overlay__required" aria-hidden="true">*</span></span>' +
          '<input class="quick-add-overlay__input" type="email" autocomplete="email" data-quick-add-property-input data-quick-add-property-name="Partner Email" required>' +
        '</label>' +
        '<div class="quick-add-overlay__waiver">' +
          '<input id="QuickAddTournamentWaiverAgreement" class="quick-add-overlay__waiver-checkbox" type="checkbox" aria-labelledby="QuickAddTournamentWaiverAgreementLabel" data-quick-add-waiver-input required>' +
          '<div id="QuickAddTournamentWaiverAgreementLabel" class="quick-add-overlay__waiver-label">' +
            'By registering, I acknowledge and agree to the terms outlined in the ' +
            '<a class="quick-add-overlay__waiver-link" href="/pages/waiver-and-liability">Waiver Release of Liability and Participant Conduct Agreement</a><span class="quick-add-overlay__waiver-required">.<span class="quick-add-overlay__required" aria-hidden="true">*</span></span>' +
          '</div>' +
        '</div>' +
        (hasSelectionButtons
          ? ''
          : '<button type="button" class="btn btn--accent quick-add-overlay__submit" data-quick-add-overlay-submit>' + escapeHtml(productStrings.addToCart || 'Add to Cart') + '</button>') +
      '</div>';
  }

  function getQuickAddTournamentPropertiesFromOverlay() {
    if (!quickAddOverlayFields) return null;
    var fields = quickAddOverlayFields.querySelector('[data-quick-add-tournament-fields]');
    if (!fields) return null;

    var properties = {};
    var isValid = true;
    var inputs = Array.from(fields.querySelectorAll('[data-quick-add-property-input]'));

    inputs.forEach(function(input) {
      var value = String(input.value || '').trim();
      input.value = value;

      if (!value) {
        isValid = false;
        if (typeof input.reportValidity === 'function') input.reportValidity();
        return;
      }

      properties[input.dataset.quickAddPropertyName] = value;
    });

    var waiverInput = fields.querySelector('[data-quick-add-waiver-input]');
    if (!waiverInput || !waiverInput.checked) {
      isValid = false;
      if (waiverInput && typeof waiverInput.reportValidity === 'function') waiverInput.reportValidity();
    } else {
      properties['Waiver Release of Liability and Participant Conduct Agreement'] = 'Yes';
    }

    return isValid ? properties : false;
  }

  function getQuickAddOverlayVariantLabel(button) {
    if (!button) return '';
    var quickAddData = getProductCardQuickAddData(button);
    var selectedOptions = quickAddData ? normalizeSelectedOptions(quickAddData.selectedOptions) : [];
    var sizeIndex = getQuickAddSelectionOptionIndex(quickAddData);

    return selectedOptions.filter(function(optionValue, index) {
      if (!optionValue || optionValue === 'Default Title') return false;
      return index !== sizeIndex;
    }).join(' - ');
  }

  function getQuickAddOverlayPriceHtml(button) {
    if (!button) return '';
    var price = parseInt(button.dataset.quickAddPrice || '0', 10) || 0;
    var compareAtPrice = parseInt(button.dataset.quickAddCompareAtPrice || '0', 10) || 0;

    if (compareAtPrice > price) {
      return '<span>' + formatMoney(price) + '</span><span class="product-card__price--compare">' + formatMoney(compareAtPrice) + '</span>';
    }

    return '<span>' + formatMoney(price) + '</span>';
  }

  function getQuickAddOverlayBadgesHtml(button) {
    if (!button) return '';

    var badges = [];
    var price = parseInt(button.dataset.quickAddPrice || '0', 10) || 0;
    var compareAtPrice = parseInt(button.dataset.quickAddCompareAtPrice || '0', 10) || 0;
    var isNew = parseBoolean(button.dataset.quickAddIsNew);
    var isAvailable = parseBoolean(button.dataset.quickAddAvailable);

    if (!isAvailable) {
      badges.push('<span class="product-card__badge product-card__badge--soldout">Sold Out</span>');
    }
    if (isNew) {
      badges.push('<span class="product-card__badge product-card__badge--new">New</span>');
    }
    if (compareAtPrice > price && compareAtPrice > 0) {
      var discountPercent = Math.round(((compareAtPrice - price) * 100) / compareAtPrice);
      badges.push('<span class="product-card__badge product-card__badge--sale">' + escapeHtml(String(discountPercent)) + '% off</span>');
    }

    if (!badges.length) return '';
    return '<div class="quick-add-overlay__product-badges">' + badges.join('') + '</div>';
  }

  function renderQuickAddOverlayProduct(button) {
    if (!quickAddOverlayProduct) return;
    if (!button) {
      quickAddOverlayProduct.innerHTML = '';
      return;
    }

    var productUrl = button.dataset.quickAddProductUrl || '#';
    var productTitle = button.dataset.quickAddProductTitle || '';
    var featuredImage = button.dataset.quickAddFeaturedImage || '';
    var variantLabel = getQuickAddOverlayVariantLabel(button);
    var priceHtml = getQuickAddOverlayPriceHtml(button);
    var badgesHtml = getQuickAddOverlayBadgesHtml(button);

    quickAddOverlayProduct.innerHTML =
      '<a class="quick-add-overlay__product-media" href="' + escapeHtml(productUrl) + '">' +
        (featuredImage ? '<img src="' + escapeHtml(featuredImage) + '" alt="' + escapeHtml(productTitle) + '" loading="lazy">' : '') +
      '</a>' +
      '<div class="quick-add-overlay__product-content">' +
        badgesHtml +
        '<a class="quick-add-overlay__product-title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(productTitle) + '</a>' +
        (variantLabel ? '<span class="quick-add-overlay__product-variant">' + escapeHtml(variantLabel) + '</span>' : '') +
        '<div class="quick-add-overlay__product-price">' + priceHtml + '</div>' +
      '</div>';
  }

  function closeQuickAddOverlay(options) {
    if (!quickAddOverlay) return;
    var settings = options || {};
    var activeButton = quickAddActiveButton;

    quickAddOverlay.classList.remove('is-open');
    quickAddOverlay.setAttribute('aria-hidden', 'true');
    if (quickAddOverlaySizes) quickAddOverlaySizes.innerHTML = '';
    if (quickAddOverlayFields) {
      quickAddOverlayFields.innerHTML = '';
      quickAddOverlayFields.hidden = true;
    }
    if (quickAddOverlayTitle) quickAddOverlayTitle.textContent = 'SELECT SIZE';
    renderQuickAddOverlayProduct(null);

    if (activeButton) {
      activeButton.setAttribute('aria-expanded', 'false');
      var activeCard = activeButton.closest('.product-card');
      if (activeCard) syncProductCardQuickAdd(activeCard);
      if (settings.returnFocus !== false) activeButton.focus();
    }

    quickAddActiveButton = null;
    if (shouldRestoreBodyScroll()) document.body.style.overflow = '';
  }

  function openQuickAddOverlay(button) {
    if (!quickAddOverlay || !button) return;
    var quickAddData = getProductCardQuickAddData(button);
    var sizeCount = buildQuickAddOverlaySizeButtons(button);
    renderQuickAddOverlayTournamentFields(button, sizeCount > 0);
    if (!sizeCount && (!quickAddData || !quickAddData.requiresTournamentFields)) {
      var card = button.closest('.product-card');
      if (card) syncProductCardQuickAdd(card);
      return;
    }

    if (quickAddActiveButton && quickAddActiveButton !== button) {
      quickAddActiveButton.setAttribute('aria-expanded', 'false');
      var previousCard = quickAddActiveButton.closest('.product-card');
      if (previousCard) syncProductCardQuickAdd(previousCard);
    }

    quickAddActiveButton = button;
    button.setAttribute('aria-expanded', 'true');
    if (quickAddOverlayTitle) {
      quickAddOverlayTitle.textContent = sizeCount
        ? 'SELECT ' + getQuickAddSelectionOptionName(quickAddData).toUpperCase()
        : 'REGISTRATION DETAILS';
    }
    renderQuickAddOverlayProduct(button);

    quickAddOverlay.classList.add('is-open');
    quickAddOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    var firstEnabledSize = quickAddOverlay.querySelector('[data-quick-add-overlay-size]:not(:disabled)');
    var firstTournamentField = quickAddOverlay.querySelector('[data-quick-add-property-input]');
    var closeButton = quickAddOverlay.querySelector('[data-quick-add-overlay-close]');
    window.setTimeout(function() {
      if (firstEnabledSize) {
        firstEnabledSize.focus();
      } else if (firstTournamentField) {
        firstTournamentField.focus();
      } else if (closeButton) {
        closeButton.focus();
      }
    }, 40);
  }

  function updateProductCardQuickAddDataset(button, data) {
    if (!button || !data) return;
    Object.keys(data).forEach(function(key) {
      button.dataset[key] = data[key];
    });
    var card = button.closest('.product-card');
    if (card) syncProductCardQuickAdd(card);
    if (quickAddOverlay && quickAddOverlay.classList.contains('is-open') && quickAddActiveButton === button) {
      var sizeCount = buildQuickAddOverlaySizeButtons(button);
      renderQuickAddOverlayTournamentFields(button, sizeCount > 0);
      if (!sizeCount && !parseBoolean(button.dataset.quickAddRequiresTournamentFields)) {
        closeQuickAddOverlay({ returnFocus: false });
        return;
      }
      if (quickAddOverlayTitle) {
        var quickAddData = getProductCardQuickAddData(button);
        quickAddOverlayTitle.textContent = sizeCount
          ? 'SELECT ' + getQuickAddSelectionOptionName(quickAddData).toUpperCase()
          : 'REGISTRATION DETAILS';
      }
      renderQuickAddOverlayProduct(button);
    }
  }

  function syncProductCardQuickAdd(card) {
    if (!card) return;
    var button = card.querySelector('[data-quick-add-trigger]');
    if (!button) return;

    var quickAddData = getProductCardQuickAddData(button);
    if (!quickAddData) return;
    var buttonLabel = button.dataset.quickAddDefaultLabel || productStrings.quickAdd;
    var hasAvailableSize = !quickAddData.hasSizeOption || getProductCardQuickAddMatchingVariants(button).some(function(variant) {
      return !!variant.available;
    });

    if (!button.classList.contains('is-loading') && !button.classList.contains('is-success')) {
      if (!quickAddData.variantId || !quickAddData.available || !hasAvailableSize) {
        buttonLabel = button.dataset.quickAddSoldOutLabel || wishlistStrings.soldOut;
      }
      setProductCardQuickAddState(button, buttonLabel, !quickAddData.variantId || !quickAddData.available || !hasAvailableSize, false, false);
    }
  }

  function submitProductCardQuickAdd(button, variantId, inventoryMeta, sourceButton, properties) {
    if (!button || !variantId) return;
    var card = button.closest('.product-card');
    var overlayButton = sourceButton && sourceButton.matches('[data-quick-add-overlay-size]') ? sourceButton : null;
    var normalizedProperties = normalizeLineItemProperties(properties);

    setProductCardQuickAddState(
      button,
      button.dataset.quickAddAddingLabel || wishlistStrings.addToBag,
      true,
      true,
      false
    );
    if (overlayButton) {
      setQuickAddOverlaySizeState(overlayButton, button.dataset.quickAddAddingLabel || wishlistStrings.addToBag, true, true, false);
    }

    Promise.resolve(refreshCartQuantities())
      .then(function(cart) {
        var inventoryGuard = getCartInventoryGuardResult(variantId, inventoryMeta);
        if (inventoryGuard.blocked) {
          setProductCardQuickAddState(button, button.dataset.quickAddDefaultLabel || productStrings.quickAdd, false, false, false);
          if (overlayButton) {
            setQuickAddOverlaySizeState(overlayButton, productStrings.addToCart, false, false, false);
          }
          handleMaxInventoryReached(variantId);
          return null;
        }

        return addWishlistVariantToCart(variantId, cart, normalizedProperties);
      })
      .then(function(result) {
        if (!result) return;
        if (!result.ok) {
          if (isInventoryLimitErrorResponse(result.data)) {
            setProductCardQuickAddState(button, button.dataset.quickAddDefaultLabel || productStrings.quickAdd, false, false, false);
            if (overlayButton) {
              setQuickAddOverlaySizeState(overlayButton, productStrings.addToCart, false, false, false);
            }
            handleMaxInventoryReached(variantId);
            return;
          }
          setProductCardQuickAddState(button, button.dataset.quickAddSoldOutLabel || wishlistStrings.soldOut, true, false, false);
          if (overlayButton) {
            setQuickAddOverlaySizeState(overlayButton, wishlistStrings.soldOut, true, false, false);
          }
          return;
        }
        if (result.data && Array.isArray(result.data.items)) {
          syncCartQuantitiesFromCart(result.data);
          var updatedItemMatch = getCartItemByVariant(result.data, variantId, normalizedProperties);
          if (!updatedItemMatch || updatedItemMatch.item.quantity < result.expectedQuantity) {
            setProductCardQuickAddState(button, button.dataset.quickAddDefaultLabel || productStrings.quickAdd, false, false, false);
            if (overlayButton) {
              setQuickAddOverlaySizeState(overlayButton, productStrings.addToCart, false, false, false);
            }
            handleMaxInventoryReached(variantId);
            return;
          }
        }

        setProductCardQuickAddState(button, button.dataset.quickAddAddedLabel || wishlistStrings.added, false, false, true);
        if (overlayButton) {
          setQuickAddOverlaySizeState(overlayButton, button.dataset.quickAddAddedLabel || wishlistStrings.added, false, false, true);
        }
        setTimeout(function() {
          closeQuickAddOverlay({ returnFocus: false });
          fetchAndRenderCart();
          openCartDrawer('bag');
        }, QUICK_ADD_SUCCESS_PREVIEW_MS);
        setTimeout(function() {
          if (overlayButton && quickAddOverlay && !quickAddOverlay.classList.contains('is-open')) {
            setQuickAddOverlaySizeState(overlayButton, productStrings.addToCart, false, false, false);
          }
          setProductCardQuickAddState(
            button,
            button.dataset.quickAddDefaultLabel || productStrings.quickAdd,
            false,
            false,
            false
          );
          syncProductCardQuickAdd(card);
        }, QUICK_ADD_SUCCESS_RESET_MS);
      })
      .catch(function() {
        if (overlayButton) {
          setQuickAddOverlaySizeState(overlayButton, productStrings.addToCart, false, false, false);
        }
        syncProductCardQuickAdd(card);
      });
  }

  function initializeProductCardQuickAdd(root) {
    (root || document).querySelectorAll('.product-card').forEach(function(card) {
      syncProductCardQuickAdd(card);
    });
  }

  function getGetTheLookCountLabel(count) {
    if (count === 1) return count + ' ' + productStrings.itemLabelOne;
    return count + ' ' + productStrings.itemLabelOther;
  }

  function getGetTheLookGroupData(trigger) {
    var groupRoot = trigger ? trigger.closest('[data-get-the-look-group]') : null;
    if (!groupRoot) return null;

    return {
      root: groupRoot,
      id: groupRoot.dataset.getTheLookId || '',
      title: groupRoot.dataset.getTheLookTitle || productStrings.getTheLook,
      count: parseWishlistInt(groupRoot.dataset.getTheLookCount) || 0,
      products: parseJson(groupRoot.dataset.getTheLookProducts, [])
    };
  }

  function getTheLookSelectionsForGroup(groupId) {
    groupId = String(groupId || '');
    if (!groupId) return {};
    if (!getTheLookSelections[groupId]) {
      getTheLookSelections[groupId] = {};
    }
    return getTheLookSelections[groupId];
  }

  function normalizeGetTheLookItems(rawItems, groupId) {
    if (!Array.isArray(rawItems)) return [];

    return rawItems.map(function(rawItem, index) {
      var itemData = rawItem && typeof rawItem === 'object' ? Object.assign({}, rawItem) : null;
      if (!itemData) return null;
      if (!itemData.wishlist_key) {
        itemData.wishlist_key = 'look:' + String(groupId || '') + ':' + String(itemData.product_handle || index) + ':' + String(index);
      }
      return normalizeWishlistItem(itemData);
    }).filter(Boolean);
  }

  function applyGetTheLookSelections(items, groupId) {
    var selections = getTheLookSelectionsForGroup(groupId);
    return items.map(function(item) {
      if (!item || !item.wishlist_key) return item;
      item.selected_size = selections[item.wishlist_key] || '';
      return item;
    });
  }

  function getTheLookItemVariantLabel(item) {
    var detailParts = getWishlistDetailParts(item);
    return detailParts.length ? detailParts.join(' - ') : '';
  }

  function buildGetTheLookSizeSelectHtml(item) {
    if (!item.has_size_option) {
      return '';
    }

    var selectedSize = item.selected_size || '';
    var options = getWishlistSizeOptions(item);

    return (
      '<div class="get-the-look-overlay__item-size-field variant-selector variant-selector--size">' +
        '<span class="variant-selector__label variant-selector__label--size-prompt">' + escapeHtml(wishlistStrings.selectSize) + '</span>' +
        '<div class="variant-selector__options variant-selector__options--size">' +
          options.map(function(option) {
            return '<button type="button" class="variant-selector__option variant-selector__option--size' +
              (selectedSize === option.value ? ' active' : '') +
              (option.available ? '' : ' variant-selector__option--oos') + '"' +
              ' data-get-the-look-size-option' +
              ' data-item-key="' + escapeHtml(item.wishlist_key) + '"' +
              ' data-size-value="' + escapeHtml(option.value) + '"' +
              (option.available ? '' : ' disabled') + '>' + escapeHtml(option.value) + '</button>';
          }).join('') +
        '</div>' +
      '</div>'
    );
  }

  function buildGetTheLookColorSelectHtml(item) {
    if (!item.has_color_option) return '';

    var selectedColor = item.color || '';
    var options = getWishlistColorOptions(item);
    if (!options.length) return '';

    return (
      '<div class="get-the-look-overlay__item-color-field">' +
        '<div class="get-the-look-overlay__item-swatches product-card__swatches" aria-label="Color">' +
          options.map(function(option) {
            var colorLower = String(option.value || '').toLowerCase().replace(/\s+/g, '-');
            return '<button type="button" class="product-card__swatch' + (selectedColor === option.value ? ' is-active' : '') + '"' +
              ' data-get-the-look-color-swatch' +
              ' data-item-key="' + escapeHtml(item.wishlist_key) + '"' +
              ' data-color-value="' + escapeHtml(option.value) + '"' +
              ' style="background: ' + escapeHtml(colorLower) + ';"' +
              ' aria-label="' + escapeHtml(option.value) + '"' +
              ' title="' + escapeHtml(option.value) + '">' +
            '</button>';
          }).join('') +
        '</div>' +
      '</div>'
    );
  }

  function buildGetTheLookAddButtonHtml(item, cardState) {
    var label = cardState.button_label || wishlistStrings.addToBag;
    return (
      '<button type="button" class="get-the-look-overlay__item-add wishlist-card__add"' + (cardState.button_disabled ? ' disabled' : '') +
        ' data-get-the-look-add data-item-key="' + escapeHtml(item.wishlist_key) + '"' +
        ' data-variant-id="' + escapeHtml(cardState.variant_id) + '"' +
        ' aria-label="' + escapeHtml(label) + '"' +
        ' title="' + escapeHtml(label) + '">' +
        '<span class="get-the-look-overlay__item-add-text" data-wishlist-add-label>' + escapeHtml(label) + '</span>' +
        '<span class="wishlist-card__add-icon wishlist-card__add-icon--bag" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24">' +
            '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<path d="M16 10a4 4 0 0 1-8 0" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</span>' +
        '<span class="wishlist-card__add-spinner" aria-hidden="true"></span>' +
        '<span class="wishlist-card__add-check" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24">' +
            '<path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</span>' +
      '</button>'
    );
  }

  function buildGetTheLookItemHtml(item) {
    var cardState = buildWishlistCardState(item);
    var variantLabel = getTheLookItemVariantLabel(item);
    var productUrl = item.product_url || ('/products/' + item.product_handle + '?variant=' + item.variant_id);
    var previewVariant = getWishlistPreviewVariant(item);
    var displayPrice = previewVariant && typeof previewVariant.price === 'number' ? previewVariant.price : item.price;
    var displayCompareAtPrice = previewVariant && typeof previewVariant.compare_at_price === 'number' ? previewVariant.compare_at_price : item.compare_at_price;
    var displayImage = previewVariant && previewVariant.image ? previewVariant.image : item.featured_image;
    var hasSaleBadge = displayCompareAtPrice > displayPrice;
    var comparePriceHtml = displayCompareAtPrice > displayPrice
      ? '<span class="product-card__price--compare">' + formatMoney(displayCompareAtPrice) + '</span>'
      : '';
    var priceHtml = '<span>' + formatMoney(displayPrice) + '</span>' + comparePriceHtml;
    var badgeHtml = '';

    if (item.is_new || hasSaleBadge) {
      var badgeParts = [];
      if (item.is_new) {
        badgeParts.push('<span class="product-card__badge product-card__badge--new">New</span>');
      }
      if (hasSaleBadge && displayCompareAtPrice > 0) {
        var discountPercent = Math.round(((displayCompareAtPrice - displayPrice) * 100) / displayCompareAtPrice);
        badgeParts.push('<span class="product-card__badge product-card__badge--sale">' + escapeHtml(String(discountPercent)) + '% off</span>');
      }
      badgeHtml = '<div class="get-the-look-overlay__item-badges">' + badgeParts.join('') + '</div>';
    }

    return (
      '<article class="get-the-look-overlay__item" data-get-the-look-item data-item-key="' + escapeHtml(item.wishlist_key) + '">' +
        '<div class="get-the-look-overlay__item-media-wrap">' +
          '<a class="get-the-look-overlay__item-media" href="' + escapeHtml(productUrl) + '">' +
            (displayImage
              ? '<img src="' + escapeHtml(displayImage) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
              : '') +
          '</a>' +
        '</div>' +
        '<div class="get-the-look-overlay__item-content">' +
          badgeHtml +
          '<div class="get-the-look-overlay__item-top">' +
            '<div class="get-the-look-overlay__item-copy">' +
              '<a class="get-the-look-overlay__item-title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(item.product_title) + '</a>' +
              '<p class="get-the-look-overlay__item-variant">' + (variantLabel ? escapeHtml(variantLabel) : '&nbsp;') + '</p>' +
              '<p class="get-the-look-overlay__item-price">' + priceHtml + '</p>' +
            '</div>' +
          '</div>' +
          '<div class="get-the-look-overlay__item-actions">' +
            buildGetTheLookColorSelectHtml(item) +
            '<span class="get-the-look-overlay__item-status wishlist-card__status' + (cardState.status_unavailable ? ' is-unavailable' : '') + '">' + escapeHtml(cardState.status_label) + '</span>' +
          '</div>' +
        '</div>' +
        '<div class="get-the-look-overlay__item-row-size">' +
          buildGetTheLookSizeSelectHtml(item) +
        '</div>' +
        '<div class="get-the-look-overlay__item-row-action">' +
          buildGetTheLookAddButtonHtml(item, cardState) +
        '</div>' +
      '</article>'
    );
  }

  function renderGetTheLookOverlayItems() {
    if (!getTheLookOverlayItems || !getTheLookActiveGroup) return;
    getTheLookOverlayItems.innerHTML = getTheLookActiveGroup.items.map(function(item) {
      return buildGetTheLookItemHtml(item);
    }).join('');
  }

  function refreshGetTheLookOverlayItem(itemKey) {
    if (!getTheLookOverlay || !getTheLookActiveGroup || !getTheLookOverlayItems) return;
    var normalizedKey = String(itemKey || '');
    if (!normalizedKey) return;

    var item = getTheLookActiveGroup.items.find(function(candidate) {
      return String(candidate.wishlist_key) === normalizedKey;
    });
    if (!item) return;

    var itemNode = Array.prototype.find.call(
      getTheLookOverlayItems.querySelectorAll('[data-get-the-look-item]'),
      function(candidate) {
        return candidate.dataset.itemKey === normalizedKey;
      }
    );
    if (!itemNode) return;

    itemNode.outerHTML = buildGetTheLookItemHtml(item);
  }

  function closeGetTheLookOverlay(options) {
    if (!getTheLookOverlay) return;
    var settings = options || {};

    getTheLookOverlay.classList.remove('is-open');
    getTheLookOverlay.setAttribute('aria-hidden', 'true');
    if (getTheLookOverlayItems) getTheLookOverlayItems.innerHTML = '';
    if (getTheLookOverlayTitle) getTheLookOverlayTitle.textContent = productStrings.getTheLook;
    if (getTheLookOverlayCount) getTheLookOverlayCount.textContent = '';

    if (getTheLookActiveTrigger) {
      getTheLookActiveTrigger.setAttribute('aria-expanded', 'false');
      if (settings.returnFocus !== false) {
        getTheLookActiveTrigger.focus();
      }
    }

    getTheLookActiveTrigger = null;
    getTheLookActiveGroup = null;

    if (shouldRestoreBodyScroll()) document.body.style.overflow = '';
  }

  function openGetTheLookOverlay(trigger) {
    if (!getTheLookOverlay || !trigger) return;

    var groupData = getGetTheLookGroupData(trigger);
    if (!groupData || !groupData.products.length) return;

    if (quickAddOverlay && quickAddOverlay.classList.contains('is-open')) {
      closeQuickAddOverlay({ returnFocus: false });
    }

    if (getTheLookActiveTrigger && getTheLookActiveTrigger !== trigger) {
      getTheLookActiveTrigger.setAttribute('aria-expanded', 'false');
    }

    getTheLookActiveTrigger = trigger;
    getTheLookActiveGroup = {
      id: groupData.id,
      title: groupData.title,
      count: groupData.count,
      items: applyGetTheLookSelections(normalizeGetTheLookItems(groupData.products, groupData.id), groupData.id)
    };

    trigger.setAttribute('aria-expanded', 'true');
    if (getTheLookOverlayTitle) getTheLookOverlayTitle.textContent = groupData.title || productStrings.getTheLook;
    if (getTheLookOverlayCount) {
      getTheLookOverlayCount.textContent = getGetTheLookCountLabel(getTheLookActiveGroup.items.length || groupData.count);
    }
    renderGetTheLookOverlayItems();

    getTheLookOverlay.classList.add('is-open');
    getTheLookOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    var closeButton = getTheLookOverlay.querySelector('[data-get-the-look-overlay-close]');
    window.setTimeout(function() {
      if (closeButton) closeButton.focus();
    }, 40);
  }

  function submitGetTheLookAdd(itemKey, button) {
    if (!getTheLookActiveGroup || !button) return;

    var item = getTheLookActiveGroup.items.find(function(candidate) {
      return String(candidate.wishlist_key) === String(itemKey || '');
    });
    if (!item) return;

    var cardState = buildWishlistCardState(item);
    var variantId = parseWishlistInt(cardState.variant_id);
    var resolvedVariant = getWishlistResolvedVariant(item);
    if (!variantId || !resolvedVariant || cardState.button_disabled) {
      refreshGetTheLookOverlayItem(item.wishlist_key);
      return;
    }

    setWishlistAddButtonState(button, wishlistStrings.adding, true, true, false);

    Promise.resolve(resolveWishlistVariantInventoryMeta(item, resolvedVariant, variantId))
      .then(function(inventoryMeta) {
        return Promise.resolve(refreshCartQuantities())
          .then(function(cart) {
            var inventoryGuard = getCartInventoryGuardResult(variantId, inventoryMeta);
            if (inventoryGuard.blocked) {
              setWishlistAddButtonState(button, wishlistStrings.addToBag, false, false, false);
              handleMaxInventoryReached(variantId);
              return null;
            }

            return addWishlistVariantToCart(variantId, cart);
          });
      })
      .then(function(result) {
        if (!result) return;

        if (!result.ok) {
          if (isInventoryLimitErrorResponse(result.data)) {
            setWishlistAddButtonState(button, wishlistStrings.addToBag, false, false, false);
            handleMaxInventoryReached(variantId);
            return;
          }

          setWishlistAddButtonState(button, wishlistStrings.soldOut, true, false, false);
          return;
        }

        if (result.data && Array.isArray(result.data.items)) {
          syncCartQuantitiesFromCart(result.data);
          var updatedItemMatch = getCartItemByVariant(result.data, variantId);
          if (!updatedItemMatch || updatedItemMatch.item.quantity < result.expectedQuantity) {
            setWishlistAddButtonState(button, wishlistStrings.addToBag, false, false, false);
            handleMaxInventoryReached(variantId);
            return;
          }
        }

        setWishlistAddButtonState(button, wishlistStrings.added, false, false, true);
        window.setTimeout(function() {
          closeGetTheLookOverlay({ returnFocus: false });
          fetchAndRenderCart();
          openCartDrawer('bag');
        }, WISHLIST_ADD_SUCCESS_PREVIEW_MS);
        window.setTimeout(function() {
          refreshGetTheLookOverlayItem(item.wishlist_key);
        }, WISHLIST_ADD_SUCCESS_RESET_MS);
      })
      .catch(function() {
        refreshGetTheLookOverlayItem(item.wishlist_key);
      });
  }

  function setCopyLinkButtonState(button, isCopied) {
    if (!button) return;
    button.classList.toggle('is-copied', isCopied);
    button.setAttribute('aria-label', isCopied ? productStrings.linkCopied : productStrings.copyLink);
    button.setAttribute('title', isCopied ? productStrings.linkCopied : productStrings.copyLink);
    var label = button.querySelector('[data-copy-product-link-label]');
    if (label) label.textContent = isCopied ? productStrings.linkCopied : productStrings.copyLink;
  }

  function copyTextToClipboard(text) {
    if (!text) return Promise.reject(new Error('Missing copy text'));

    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function(resolve, reject) {
      var textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.setAttribute('readonly', 'readonly');
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      textArea.style.pointerEvents = 'none';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        if (document.execCommand('copy')) {
          resolve();
        } else {
          reject(new Error('Copy command failed'));
        }
      } catch (error) {
        reject(error);
      } finally {
        textArea.remove();
      }
    });
  }

  function getWishlistMatchingVariants(item) {
    if (!item || !item.variants || !item.variants.length) return [];
    var selectedOptions = normalizeSelectedOptions(item.selected_options);
    var selectorIndex = item.has_selector_option ? item.selector_option_index : item.size_option_index;

    return item.variants.filter(function(variant) {
      return variant.options.every(function(optionValue, index) {
        if (index === selectorIndex) return true;
        return !selectedOptions[index] || selectedOptions[index] === optionValue;
      });
    });
  }

  function getWishlistSizeOptions(item) {
    if (!item || (!item.has_selector_option && !item.has_size_option)) return [];

    var selectorIndex = item.has_selector_option ? item.selector_option_index : item.size_option_index;

    var seen = {};
    return getWishlistMatchingVariants(item).reduce(function(options, variant) {
      var sizeValue = variant.options[selectorIndex] || '';
      if (!sizeValue || seen[sizeValue]) return options;
      seen[sizeValue] = true;
      options.push({
        value: sizeValue,
        available: !!variant.available,
        variant_id: variant.id
      });
      return options;
    }, []);
  }

  function getWishlistColorOptions(item) {
    if (!item || !item.has_color_option || !item.variants || !item.variants.length) return [];

    var seen = {};
    return item.variants.reduce(function(options, variant) {
      var colorValue = variant.options[item.color_option_index] || '';
      if (!colorValue || seen[colorValue]) return options;
      seen[colorValue] = true;
      options.push({
        value: colorValue,
        available: !!variant.available
      });
      return options;
    }, []);
  }

  function getWishlistResolvedVariant(item) {
    if (!item) return null;

    if (!item.has_selector_option && !item.has_size_option) {
      if (item.variants && item.variants.length) {
        var selectedOptions = normalizeSelectedOptions(item.selected_options);
        var optionMatchedVariant = item.variants.find(function(variant) {
          return variant.options.every(function(optionValue, index) {
            return !selectedOptions[index] || selectedOptions[index] === optionValue;
          });
        });
        if (optionMatchedVariant) return optionMatchedVariant;
        return item.variants.find(function(variant) {
          return variant.id === item.variant_id;
        }) || null;
      }
      return item.variant_id ? { id: item.variant_id, available: item.available, options: normalizeSelectedOptions(item.selected_options) } : null;
    }

    var selectorIndex = item.has_selector_option ? item.selector_option_index : item.size_option_index;
    if (!item.selected_size) return null;
    return getWishlistMatchingVariants(item).find(function(variant) {
      return variant.options[selectorIndex] === item.selected_size;
    }) || null;
  }

  function buildWishlistCardState(item) {
    var resolvedVariant = getWishlistResolvedVariant(item);
    var hasSizePrompt = item.has_selector_option || item.has_size_option;
    var sizeOptions = hasSizePrompt ? getWishlistSizeOptions(item) : [];

    if (hasSizePrompt && !sizeOptions.length) {
      return {
        variant_id: '',
        button_label: wishlistStrings.unavailable,
        button_disabled: true,
        status_label: wishlistStrings.unavailable,
        status_unavailable: true
      };
    }

    if (hasSizePrompt && !item.selected_size) {
      return {
        variant_id: '',
        button_label: wishlistStrings.addToBag,
        button_disabled: true,
        status_label: '',
        status_unavailable: false
      };
    }

    if (!resolvedVariant) {
      return {
        variant_id: '',
        button_label: wishlistStrings.unavailable,
        button_disabled: true,
        status_label: wishlistStrings.unavailable,
        status_unavailable: true
      };
    }

    if (!resolvedVariant.available) {
      return {
        variant_id: String(resolvedVariant.id),
        button_label: wishlistStrings.soldOut,
        button_disabled: true,
        status_label: wishlistStrings.soldOut,
        status_unavailable: true
      };
    }

    return {
      variant_id: String(resolvedVariant.id),
      button_label: wishlistStrings.addToBag,
      button_disabled: false,
      status_label: '',
      status_unavailable: false
    };
  }

  function getWishlistPreviewVariant(item) {
    if (!item || !item.variants || !item.variants.length) return null;

    var resolvedVariant = getWishlistResolvedVariant(item);
    if (resolvedVariant) return resolvedVariant;

    return getWishlistMatchingVariants(item).find(function(variant) {
      return !!variant.available;
    }) || getWishlistMatchingVariants(item)[0] || null;
  }

  function buildWishlistSizeSelectHtml(item) {
    var selectorLabel = item && item.selector_option_name ? item.selector_option_name : wishlistStrings.size;

    if (!item.has_selector_option && !item.has_size_option) {
      return (
        '<label class="wishlist-card__size-field">' +
          '<select class="wishlist-card__size-select" aria-label="' + escapeHtml(selectorLabel) + '" disabled>' +
            '<option value="one-size" selected>' + escapeHtml('One size') + '</option>' +
          '</select>' +
        '</label>'
      );
    }

    var selectedSize = item.selected_size || '';
    var options = getWishlistSizeOptions(item);
    var placeholderOption = selectedSize
      ? '<option value="" disabled hidden>' + escapeHtml(selectorLabel) + '</option>'
      : '<option value="" selected disabled hidden>' + escapeHtml(selectorLabel) + '</option>';

    return (
      '<label class="wishlist-card__size-field">' +
        '<select class="wishlist-card__size-select" data-wishlist-size-select data-wishlist-key="' + escapeHtml(item.wishlist_key) + '" aria-label="' + escapeHtml(selectorLabel) + '">' +
          placeholderOption +
          options.map(function(option) {
            return '<option value="' + escapeHtml(option.value) + '"' + (selectedSize === option.value ? ' selected' : '') + '>' + escapeHtml(option.value) + '</option>';
          }).join('') +
        '</select>' +
      '</label>'
    );
  }

  function getWishlistAddButtonHtml(cardState, wishlistKey) {
    var label = cardState.button_label || wishlistStrings.addToBag;
    return (
      '<button type="button" class="wishlist-card__add"' + (cardState.button_disabled ? ' disabled' : '') +
        ' data-wishlist-add data-wishlist-key="' + escapeHtml(wishlistKey) + '"' +
        ' data-variant-id="' + escapeHtml(cardState.variant_id) + '"' +
        ' aria-label="' + escapeHtml(label) + '"' +
        ' title="' + escapeHtml(label) + '">' +
        '<span class="wishlist-card__add-icon wishlist-card__add-icon--bag" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24">' +
            '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<path d="M16 10a4 4 0 0 1-8 0" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</span>' +
        '<span class="wishlist-card__add-spinner" aria-hidden="true"></span>' +
        '<span class="wishlist-card__add-check" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24">' +
            '<path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</span>' +
        '<span class="visually-hidden" data-wishlist-add-label>' + escapeHtml(label) + '</span>' +
      '</button>'
    );
  }

  function buildWishlistTournamentFieldsHtml(item, mode, cardState) {
    if (!item || !item.requires_tournament_fields) return '';

    var fieldClassName = mode === 'drawer'
      ? 'wishlist-tournament-fields wishlist-tournament-fields--drawer'
      : 'wishlist-tournament-fields';
    var waiverInputId = 'WishlistWaiverAgreement-' + String(item.wishlist_key || '').replace(/[^a-zA-Z0-9_-]/g, '-');
    var waiverLabelId = waiverInputId + '-Label';
    var playerFieldHtml =
      '<label class="wishlist-tournament-fields__field">' +
        '<span class="wishlist-tournament-fields__label">Player Full Name <span class="wishlist-tournament-fields__required" aria-hidden="true">*</span></span>' +
        '<input class="wishlist-tournament-fields__input" type="text" value="' + escapeHtml(item.tournament_player_full_name || '') + '" data-wishlist-property-input data-wishlist-key="' + escapeHtml(item.wishlist_key) + '" data-wishlist-property-key="tournament_player_full_name" placeholder="Player full name" required>' +
      '</label>';
    var duprFieldHtml =
      '<label class="wishlist-tournament-fields__field wishlist-tournament-fields__field--dupr">' +
        '<span class="wishlist-tournament-fields__label">Your DUPR <span class="wishlist-tournament-fields__required" aria-hidden="true">*</span></span>' +
        '<input class="wishlist-tournament-fields__input" type="text" value="' + escapeHtml(item.tournament_dupr || '') + '" data-wishlist-property-input data-wishlist-key="' + escapeHtml(item.wishlist_key) + '" data-wishlist-property-key="tournament_dupr" placeholder="3.0 (NR if you don\'t have one)" required>' +
      '</label>';
    var partnerEmailFieldHtml =
      '<label class="wishlist-tournament-fields__field">' +
        '<span class="wishlist-tournament-fields__label">Partner Email <span class="wishlist-tournament-fields__required" aria-hidden="true">*</span></span>' +
        '<input class="wishlist-tournament-fields__input" type="email" value="' + escapeHtml(item.tournament_partner_email || '') + '" data-wishlist-property-input data-wishlist-key="' + escapeHtml(item.wishlist_key) + '" data-wishlist-property-key="tournament_partner_email" placeholder="Partner email" required>' +
      '</label>';

    return (
      '<div class="' + fieldClassName + '" data-wishlist-tournament-fields>' +
        playerFieldHtml +
        duprFieldHtml +
        '<label class="wishlist-tournament-fields__field">' +
          '<span class="wishlist-tournament-fields__label">Partner Full Name <span class="wishlist-tournament-fields__required" aria-hidden="true">*</span></span>' +
          '<input class="wishlist-tournament-fields__input" type="text" value="' + escapeHtml(item.tournament_partner_full_name || '') + '" data-wishlist-property-input data-wishlist-key="' + escapeHtml(item.wishlist_key) + '" data-wishlist-property-key="tournament_partner_full_name" placeholder="Partner full name" required>' +
        '</label>' +
        partnerEmailFieldHtml +
        (mode === 'drawer'
          ? ''
          : '<div class="wishlist-tournament-fields__row">' +
              getWishlistAddButtonHtml(cardState, item.wishlist_key) +
            '</div>') +
        '<div class="wishlist-waiver">' +
          '<input id="' + escapeHtml(waiverInputId) + '" class="wishlist-waiver__checkbox" type="checkbox" aria-labelledby="' + escapeHtml(waiverLabelId) + '" data-wishlist-waiver-input required>' +
          '<div id="' + escapeHtml(waiverLabelId) + '" class="wishlist-waiver__label">' +
            'By registering, I acknowledge and agree to the terms outlined in the ' +
            '<a class="wishlist-waiver__link" href="/pages/waiver-and-liability">Waiver Release of Liability and Participant Conduct Agreement</a><span class="wishlist-waiver__required">.<span class="wishlist-tournament-fields__required" aria-hidden="true">*</span></span>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function setWishlistAddButtonState(button, label, isDisabled, isLoading, isSuccess) {
    if (!button) return;
    var resolvedLabel = label || wishlistStrings.addToBag;
    button.disabled = !!isDisabled;
    button.classList.toggle('is-loading', !!isLoading);
    button.classList.toggle('is-success', !!isSuccess);
    button.setAttribute('aria-label', resolvedLabel);
    button.setAttribute('title', resolvedLabel);
    var hiddenLabel = button.querySelector('[data-wishlist-add-label]');
    if (hiddenLabel) hiddenLabel.textContent = resolvedLabel;
  }

  function getWishlistItemByKey(wishlistKey) {
    wishlistKey = String(wishlistKey || '');
    if (!wishlistKey) return null;
    return applyWishlistSelections(loadWishlist()).find(function(item) {
      return String(item.wishlist_key) === wishlistKey;
    }) || null;
  }

  function updateWishlistItemFields(wishlistKey, fieldUpdates, shouldRefreshUi) {
    wishlistKey = String(wishlistKey || '');
    if (!wishlistKey || !fieldUpdates || typeof fieldUpdates !== 'object') return;

    var items = loadWishlist();
    var didUpdate = false;

    items.forEach(function(item) {
      if (!item || String(item.wishlist_key) !== wishlistKey) return;
      Object.keys(fieldUpdates).forEach(function(fieldName) {
        item[fieldName] = fieldUpdates[fieldName];
      });
      didUpdate = true;
    });

    if (!didUpdate) return;
    saveWishlist(items);
    if (shouldRefreshUi) {
      publishWishlistUpdate();
    }
  }

  function getWishlistTournamentPropertiesFromCard(card, wishlistItem) {
    if (!wishlistItem || !wishlistItem.requires_tournament_fields) return null;
    if (!card) return null;

    var inputs = Array.from(card.querySelectorAll('[data-wishlist-property-input]'));
    if (!inputs.length) return null;

    var properties = {};
    var isValid = true;

    inputs.forEach(function(input) {
      var value = String(input.value || '').trim();
      input.value = value;

      if (!value) {
        isValid = false;
        if (typeof input.reportValidity === 'function') {
          input.reportValidity();
        }
        return;
      }

      if (input.dataset.wishlistPropertyKey === 'tournament_player_full_name') {
        properties['Player Full Name'] = value;
      } else if (input.dataset.wishlistPropertyKey === 'tournament_partner_full_name') {
        properties['Partner Full Name'] = value;
      } else if (input.dataset.wishlistPropertyKey === 'tournament_partner_email') {
        properties['Partner Email'] = value;
      } else if (input.dataset.wishlistPropertyKey === 'tournament_dupr') {
        properties['Your DUPR'] = value;
      }
    });

    var waiverInput = card.querySelector('[data-wishlist-waiver-input]');
    if (!waiverInput || !waiverInput.checked) {
      isValid = false;
      if (waiverInput && typeof waiverInput.reportValidity === 'function') {
        waiverInput.reportValidity();
      }
    } else {
      properties['Waiver Release of Liability and Participant Conduct Agreement'] = 'Yes';
    }

    return isValid ? properties : false;
  }

  function getWishlistDetailParts(item) {
    var detailParts = [];
    var selectedSize = (item.has_selector_option || item.has_size_option) ? (item.selected_size || '') : (item.size || '');
    var seenDetailParts = {};

    function pushDetailPart(value) {
      var normalizedValue = String(value || '').trim();
      var normalizedKey = normalizedValue.toLowerCase();

      if (!normalizedValue || seenDetailParts[normalizedKey]) return;

      seenDetailParts[normalizedKey] = true;
      detailParts.push(normalizedValue);
    }

    if (item.color) {
      pushDetailPart(item.color);
    }

    if (item.has_selector_option || item.has_size_option) {
      var selectorIndex = item.has_selector_option ? item.selector_option_index : item.size_option_index;
      normalizeSelectedOptions(item.selected_options).forEach(function(optionValue, index) {
        if (!optionValue || index === selectorIndex) return;
        pushDetailPart(optionValue);
      });
    }

    if (selectedSize) {
      pushDetailPart(selectedSize);
    }

    if (!detailParts.length && item.variant_title && item.variant_title !== 'Default Title' && !item.has_selector_option && !item.has_size_option) {
      pushDetailPart(item.variant_title);
    }

    return detailParts;
  }

  function buildWishlistItemHtml(item, mode) {
    var isDrawer = mode === 'drawer';
    var detailParts = getWishlistDetailParts(item);
    var variantLabel = detailParts.length ? detailParts.join(' - ') : '';
    var productUrl = item.product_url || ('/products/' + item.product_handle + '?variant=' + item.variant_id);
    var cardState = buildWishlistCardState(item);
    var hasSaleBadge = item.compare_at_price > item.price;
    var hasBadgeStack = item.is_new || hasSaleBadge;
    var discountPercent = hasSaleBadge
      ? Math.round(((item.compare_at_price - item.price) * 100) / item.compare_at_price)
      : 0;
    var comparePriceHtml = item.compare_at_price > item.price
      ? '<span class="product-card__price--compare">' + formatMoney(item.compare_at_price) + '</span>'
      : '';
    var priceHtml = '<span>' + formatMoney(item.price) + '</span>' + comparePriceHtml;

    if (isDrawer) {
      return (
        '<article class="cart-item wishlist-drawer-item" data-wishlist-card data-wishlist-key="' + escapeHtml(item.wishlist_key) + '">' +
          '<div class="wishlist-drawer-item__media-wrap">' +
            '<a class="cart-item__image wishlist-drawer-item__image" href="' + escapeHtml(productUrl) + '">' +
              (item.featured_image
                ? '<img src="' + escapeHtml(item.featured_image) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
                : '') +
            '</a>' +
          '</div>' +
          '<div class="cart-item__details wishlist-drawer-item__details">' +
            (hasBadgeStack
              ? '<div class="cart-item__badge-row wishlist-drawer-item__badge-row">' +
                  (item.is_new ? '<span class="product-card__badge product-card__badge--new">New</span>' : '') +
                  (hasSaleBadge ? '<span class="product-card__badge product-card__badge--sale">' + escapeHtml(String(discountPercent)) + '% off</span>' : '') +
                '</div>'
              : '') +
            '<a class="cart-item__title wishlist-drawer-item__title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(item.product_title) + '</a>' +
            '<p class="cart-item__variant wishlist-drawer-item__variant">' + (variantLabel ? escapeHtml(variantLabel) : '&nbsp;') + '</p>' +
            '<div class="cart-item__qty wishlist-drawer-item__size-row">' +
              buildWishlistSizeSelectHtml(item) +
            '</div>' +
            buildWishlistTournamentFieldsHtml(item, mode, cardState) +
          '</div>' +
          '<div class="cart-item__aside wishlist-drawer-item__aside">' +
            '<button type="button" class="cart-item__wishlist-indicator wishlist-drawer-item__remove is-active" data-wishlist-remove="' + escapeHtml(item.wishlist_key) + '" aria-label="' + escapeHtml(wishlistStrings.remove) + '" title="' + escapeHtml(wishlistStrings.remove) + '">' +
              '<svg viewBox="0 0 24 24" aria-hidden="true">' +
                '<path d="M12 21.35 10.55 20C5.4 15.24 2 12.09 2 8.25 2 5.22 4.42 3 7.3 3c1.64 0 3.21.76 4.2 1.96C12.49 3.76 14.06 3 15.7 3 18.58 3 21 5.22 21 8.25c0 3.84-3.4 6.99-8.55 11.76L12 21.35Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg>' +
              '<span class="visually-hidden">' + escapeHtml(wishlistStrings.remove) + '</span>' +
            '</button>' +
            '<p class="cart-item__price wishlist-drawer-item__price">' + priceHtml + '</p>' +
            '<div class="wishlist-drawer-item__actions">' +
              '<span class="wishlist-card__status wishlist-drawer-item__status' + (cardState.status_unavailable ? ' is-unavailable' : '') + '">' + escapeHtml(cardState.status_label) + '</span>' +
              getWishlistAddButtonHtml(cardState, item.wishlist_key) +
            '</div>' +
          '</div>' +
        '</article>'
      );
    }

    return (
      '<article class="wishlist-card" data-wishlist-card data-wishlist-key="' + escapeHtml(item.wishlist_key) + '">' +
        '<div class="wishlist-card__media-wrap">' +
          '<a class="wishlist-card__media" href="' + escapeHtml(productUrl) + '">' +
            (item.featured_image
              ? '<img src="' + escapeHtml(item.featured_image) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
              : '') +
          '</a>' +
          (hasBadgeStack
            ? '<div class="product-card__badge-stack">' +
                (item.is_new ? '<span class="product-card__badge product-card__badge--new">New</span>' : '') +
                (hasSaleBadge ? '<span class="product-card__badge product-card__badge--sale">' + escapeHtml(String(discountPercent)) + '% off</span>' : '') +
              '</div>'
            : '') +
          '<button type="button" class="wishlist-toggle product-card__wishlist wishlist-card__remove-heart is-active" data-wishlist-remove="' + escapeHtml(item.wishlist_key) + '" aria-label="' + escapeHtml(wishlistStrings.remove) + '" title="' + escapeHtml(wishlistStrings.remove) + '">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true">' +
              '<path d="M12 21.35 10.55 20C5.4 15.24 2 12.09 2 8.25 2 5.22 4.42 3 7.3 3c1.64 0 3.21.76 4.2 1.96C12.49 3.76 14.06 3 15.7 3 18.58 3 21 5.22 21 8.25c0 3.84-3.4 6.99-8.55 11.76L12 21.35Z" />' +
            '</svg>' +
            '<span class="visually-hidden">' + escapeHtml(wishlistStrings.remove) + '</span>' +
          '</button>' +
        '</div>' +
        '<div class="wishlist-card__content">' +
          '<div class="wishlist-card__top">' +
            '<div>' +
              '<a class="wishlist-card__title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(item.product_title) + '</a>' +
              '<p class="wishlist-card__variant">' + (variantLabel ? escapeHtml(variantLabel) : '&nbsp;') + '</p>' +
              '<p class="wishlist-card__price">' + priceHtml + '</p>' +
            '</div>' +
          '</div>' +
          '<div class="wishlist-card__actions">' +
            buildWishlistSizeSelectHtml(item) +
            buildWishlistTournamentFieldsHtml(item, mode, cardState) +
            '<span class="wishlist-card__status' + (cardState.status_unavailable ? ' is-unavailable' : '') + '">' + escapeHtml(cardState.status_label) + '</span>' +
            (item.requires_tournament_fields ? '' : getWishlistAddButtonHtml(cardState, item.wishlist_key)) +
          '</div>' +
        '</div>' +
      '</article>'
    );
  }

  function buildWishlistItemsHtml(items, mode) {
    return items.map(function(item) {
      return buildWishlistItemHtml(item, mode);
    }).join('');
  }

  function buildWishlistEmptyHtml(root) {
    return (
      '<div class="wishlist-empty">' +
        '<div class="wishlist-empty__icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24"><path d="M12 21.35 10.55 20C5.4 15.24 2 12.09 2 8.25 2 5.22 4.42 3 7.3 3c1.64 0 3.21.76 4.2 1.96C12.49 3.76 14.06 3 15.7 3 18.58 3 21 5.22 21 8.25c0 3.84-3.4 6.99-8.55 11.76L12 21.35Z"/></svg>' +
        '</div>' +
        '<h2 class="wishlist-empty__title">' + escapeHtml(root.dataset.emptyHeading) + '</h2>' +
        '<p class="wishlist-empty__body">' + escapeHtml(root.dataset.emptyBody) + '</p>' +
        '<a class="btn btn--accent wishlist-empty__cta" href="' + escapeHtml(root.dataset.emptyCtaUrl) + '">' + escapeHtml(root.dataset.emptyCtaLabel) + '</a>' +
      '</div>'
    );
  }

  function renderWishlistCollection(rootSelector, gridSelector, items) {
    var root = document.querySelector(rootSelector);
    var grid = document.querySelector(gridSelector);
    if (!root || !grid) return;

    if (!items.length) {
      grid.innerHTML = buildWishlistEmptyHtml(root);
      return;
    }

    grid.innerHTML = buildWishlistItemsHtml(items, rootSelector === '[data-wishlist-drawer]' ? 'drawer' : 'page');
  }

  function renderWishlistPage(items) {
    renderWishlistCollection('[data-wishlist-page]', '[data-wishlist-grid]', items);
  }

  function renderWishlistDrawer(items) {
    renderWishlistCollection('[data-wishlist-drawer]', '[data-wishlist-drawer-grid]', items);
  }

  var productComponentStates = new WeakMap();

  function getProductJson(root, selector, fallback) {
    if (!root) return fallback;
    var script = root.querySelector(selector);
    if (!script) return fallback;
    return parseJson(script.textContent, fallback);
  }

  function getProductComponentRoot(element) {
    return element ? element.closest('[data-product-component], .product-page') : null;
  }

  function getProductComponentState(root) {
    if (!root) return null;
    if (productComponentStates.has(root)) return productComponentStates.get(root);

    var isGlobalProductPage = root.classList.contains('product-page') && !root.hasAttribute('data-product-component');
    var state = {
      root: root,
      variants: getProductJson(root, '[data-product-variants-json]', isGlobalProductPage ? window.productVariants || [] : []),
      productData: getProductJson(root, '[data-product-data-json]', isGlobalProductPage ? window.productData || {} : {}),
      productInventory: getProductJson(root, '[data-product-inventory-json]', isGlobalProductPage ? window.productInventory || {} : {}),
      galleryHeroImages: getProductJson(root, '[data-product-gallery-hero-json]', isGlobalProductPage ? window.productGalleryHeroImages || {} : {}),
      galleryDefaultHero: getProductJson(root, '[data-product-gallery-default-json]', isGlobalProductPage ? window.productGalleryDefaultHero || null : null),
      priceEl: root.querySelector('[data-product-price]') || root.querySelector('#product-price'),
      hiddenSelect: root.querySelector('[data-product-variant-select]') || root.querySelector('select[name="id"]'),
      addToCartBtn: root.querySelector('.add-to-cart-btn'),
      productBadgeRow: root.querySelector('[data-product-badge-row]'),
      productDiscountBadge: root.querySelector('[data-product-discount-badge]'),
      productInventoryStatus: root.querySelector('[data-product-inventory-status]'),
      productGallery: root.querySelector('[data-product-gallery]'),
      productGalleryWrapper: root.querySelector('.product-gallery-wrapper'),
      galleryHeroImage: root.querySelector('[data-product-gallery-hero-image]') || root.querySelector('#product-gallery-hero-image'),
      selectedOptionLabels: Array.from(root.querySelectorAll('[data-selected-option-label]')),
      sizeSelector: root.querySelector('[data-size-selector]'),
      sizeSelectorError: root.querySelector('[data-size-selector-error]')
    };

    state.productGallerySlides = state.productGallery ? Array.from(state.productGallery.querySelectorAll('[data-product-gallery-slide]')) : [];
    state.productGalleryDots = state.productGalleryWrapper ? Array.from(state.productGalleryWrapper.querySelectorAll('[data-product-gallery-dot]')) : [];
    productComponentStates.set(root, state);
    return state;
  }

  function getSelectedOptionsForState(state) {
    var selectedOptions = [];
    Array.from(state.root.querySelectorAll('.variant-selector')).forEach(function(sel) {
      var active = sel.querySelector('.variant-selector__option.active');
      var optionIndex = parseInt(sel.dataset.optionIndex, 10);
      selectedOptions[optionIndex] = active ? active.dataset.value : null;
    });
    return selectedOptions;
  }

  function getSelectedVariantForState(state) {
    var selectedOptions = getSelectedOptionsForState(state);
    return state.variants.find(function(variant) {
      return selectedOptions.every(function(option, index) {
        return option === null || variant.options[index] === option;
      });
    });
  }

  function updatePriceForState(state, variant) {
    if (!state.priceEl || !variant) return;
    if (variant.compare_at_price > variant.price) {
      state.priceEl.innerHTML = '<span class="product-card__price--sale">' + formatMoney(variant.price) + '</span> <span class="product-card__price--compare">' + formatMoney(variant.compare_at_price) + '</span>';
    } else {
      state.priceEl.textContent = formatMoney(variant.price);
    }
  }

  function updateProductBadgesForState(state, variant) {
    if (!state.productDiscountBadge) return;
    var compareAtPrice = parseInt(variant && variant.compare_at_price, 10) || 0;
    var price = parseInt(variant && variant.price, 10) || 0;
    var hasDiscount = compareAtPrice > price;
    if (hasDiscount) {
      var discountPercent = Math.round(((compareAtPrice - price) * 100) / compareAtPrice);
      state.productDiscountBadge.textContent = discountPercent + '% off';
      state.productDiscountBadge.classList.remove('hidden');
    } else {
      state.productDiscountBadge.classList.add('hidden');
    }
    if (state.productBadgeRow) {
      var hasVisibleBadge = Array.from(state.productBadgeRow.children).some(function(child) {
        return !child.classList.contains('hidden');
      });
      state.productBadgeRow.classList.toggle('hidden', !hasVisibleBadge);
    }
  }

  function updateGalleryHeroForState(state, variant) {
    if (!state.galleryHeroImage) return;
    var hero = variant && state.galleryHeroImages[variant.id] ? state.galleryHeroImages[variant.id] : state.galleryDefaultHero;
    if (!hero || !hero.src) return;
    state.galleryHeroImage.src = hero.src;
    state.galleryHeroImage.alt = hero.alt || state.galleryHeroImage.alt;
  }

  function setActiveGallerySlideForState(state, index) {
    state.productGallerySlides.forEach(function(slide, slideIndex) {
      slide.classList.toggle('is-active', slideIndex === index);
    });

    if (!state.productGalleryDots.length) return;
    state.productGalleryDots.forEach(function(dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === index);
    });
  }

  function isMobileGalleryViewport() {
    return window.matchMedia(MOBILE_LAYOUT_QUERY).matches;
  }

  function resetGalleryLiveStylesForState(state) {
    state.productGalleryDots.forEach(function(dot) {
      dot.style.removeProperty('--gallery-dot-width');
      dot.style.removeProperty('--gallery-dot-opacity');
      dot.style.removeProperty('--gallery-dot-bg');
    });
  }

  function syncGalleryLiveStateForState(state) {
    if (!state.productGallery || state.productGallerySlides.length <= 1) return;

    if (!isMobileGalleryViewport()) {
      resetGalleryLiveStylesForState(state);
      setActiveGallerySlideForState(state, 0);
      return;
    }

    var viewportWidth = state.productGallery.clientWidth || 1;
    var viewportCenter = state.productGallery.scrollLeft + (viewportWidth / 2);
    var rawIndex = state.productGallery.scrollLeft / viewportWidth;
    var leadingIndex = Math.floor(rawIndex);
    var trailingIndex = Math.min(state.productGallerySlides.length - 1, leadingIndex + 1);
    var transitionProgress = Math.max(0, Math.min(1, rawIndex - leadingIndex));
    var isTransitioning = transitionProgress > 0.001;
    var activeIndex = 0;
    var strongestVisibility = -1;

    state.productGallerySlides.forEach(function(slide, index) {
      var slideCenter = slide.offsetLeft + (slide.offsetWidth / 2);
      var distance = Math.abs(viewportCenter - slideCenter);
      var visibility = Math.max(0, 1 - (distance / viewportWidth));
      var dotWidth = 5 + (visibility * 19);
      var dotOpacity = 0.7 + (visibility * 0.3);
      var isImmediateFillDot = index === leadingIndex || (isTransitioning && index === trailingIndex);

      if (isTransitioning) {
        if (index === leadingIndex) {
          dotWidth = 5 + ((1 - Math.pow(transitionProgress, 0.6)) * 19);
        } else if (index === trailingIndex) {
          dotWidth = 5 + (transitionProgress * 19);
        }
      }

      if (state.productGalleryDots[index]) {
        state.productGalleryDots[index].style.setProperty('--gallery-dot-width', dotWidth.toFixed(2) + 'px');
        state.productGalleryDots[index].style.setProperty('--gallery-dot-opacity', dotOpacity.toFixed(3));
        state.productGalleryDots[index].style.setProperty('--gallery-dot-bg', isImmediateFillDot ? '#000' : '#d2d5da');
      }

      if (visibility > strongestVisibility) {
        strongestVisibility = visibility;
        activeIndex = index;
      }
    });

    setActiveGallerySlideForState(state, activeIndex);
  }

  function getGallerySlideIndexForState(state) {
    if (!state.productGallery || state.productGallerySlides.length <= 1) return 0;
    var scrollLeft = state.productGallery.scrollLeft;
    var closestIndex = 0;
    var closestDistance = Infinity;

    state.productGallerySlides.forEach(function(slide, index) {
      var distance = Math.abs(slide.offsetLeft - scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function syncGalleryStatusForState(state) {
    if (isMobileGalleryViewport()) {
      syncGalleryLiveStateForState(state);
      return;
    }
    setActiveGallerySlideForState(state, getGallerySlideIndexForState(state));
  }

  function observeGallerySlidesForState(state) {
    if (!state.productGallery || state.productGallerySlides.length <= 1 || !state.productGalleryDots.length || typeof IntersectionObserver === 'undefined') {
      return;
    }

    var activeIndex = 0;
    var observer = new IntersectionObserver(function(entries) {
      if (!isMobileGalleryViewport()) return;
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var slideIndex = state.productGallerySlides.indexOf(entry.target);
        if (slideIndex === -1) return;
        if (entry.intersectionRatio >= 0.6) {
          activeIndex = slideIndex;
        }
      });

      setActiveGallerySlideForState(state, activeIndex);
    }, {
      root: state.productGallery,
      threshold: [0.6, 0.8]
    });

    state.productGallerySlides.forEach(function(slide) {
      observer.observe(slide);
    });
  }

  function updateSelectedOptionLabelForState(state, button) {
    if (!button || !state.selectedOptionLabels.length) return;
    var label = button.dataset.optionLabel || button.dataset.value || '';
    state.selectedOptionLabels.forEach(function(el) {
      el.textContent = label;
    });
  }

  function getAddToCartButtonLabel(button, labelName, fallback) {
    if (!button) return fallback;
    var dataKey = labelName + 'Label';
    return button.dataset[dataKey] || fallback;
  }

  function updateAddToCartStateForState(state, variant) {
    if (!state.addToCartBtn) return;
    var labelEl = state.addToCartBtn.querySelector('.add-to-cart-btn__label');
    var addLabel = getAddToCartButtonLabel(state.addToCartBtn, 'add', 'Add to Bag');
    var soldOutLabel = getAddToCartButtonLabel(state.addToCartBtn, 'soldOut', 'Sold Out');
    if (variant && variant.available) {
      state.addToCartBtn.disabled = false;
      state.addToCartBtn.classList.remove('is-loading');
      state.addToCartBtn.classList.remove('is-success');
      if (labelEl) {
        labelEl.textContent = addLabel;
      } else {
        state.addToCartBtn.textContent = addLabel;
      }
      return;
    }
    state.addToCartBtn.disabled = true;
    state.addToCartBtn.classList.remove('is-loading');
    state.addToCartBtn.classList.remove('is-success');
    if (labelEl) {
      labelEl.textContent = soldOutLabel;
    } else {
      state.addToCartBtn.textContent = soldOutLabel;
    }
  }

  function updateProductInventoryStatusForState(state, variant) {
    if (!state.productInventoryStatus || !variant) return;
    var inventory = state.productInventory && state.productInventory[variant.id];
    var quantity = inventory ? parseInt(inventory.qty, 10) || 0 : 0;
    var tracksInventory = !!(inventory && inventory.mgmt && inventory.policy === 'deny');

    state.productInventoryStatus.classList.toggle('hidden', !tracksInventory);
    if (!tracksInventory) return;

    quantity = Math.max(quantity, 0);
    state.productInventoryStatus.textContent = quantity + ' Spot' + (quantity === 1 ? '' : 's') + ' Left';
  }

  function isOptionValueAvailableForState(state, optionIndex, value, selections) {
    return state.variants.some(function(variant) {
      if (!variant.available || variant.options[optionIndex] !== value) return false;
      return variant.options.every(function(optionValue, index) {
        if (index === optionIndex) return true;
        return !selections[index] || selections[index] === optionValue;
      });
    });
  }

  function syncOptionAvailabilityForState(state) {
    var selections = getSelectedOptionsForState(state);
    Array.from(state.root.querySelectorAll('.variant-selector')).forEach(function(selector) {
      var optionIndex = parseInt(selector.dataset.optionIndex, 10);
      selector.querySelectorAll('.variant-selector__option').forEach(function(button) {
        var isAvailable = isOptionValueAvailableForState(state, optionIndex, button.dataset.value, selections);
        button.disabled = !isAvailable;
        button.classList.toggle('variant-selector__option--oos', !isAvailable);
        button.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
      });
    });
  }

  function syncVariantStateForState(state) {
    if (!state || !state.variants.length) return;
    syncOptionAvailabilityForState(state);
    var variant = getSelectedVariantForState(state);
    if (state.hiddenSelect) {
      state.hiddenSelect.value = variant ? variant.id : '';
    }
    updatePriceForState(state, variant);
    updateProductBadgesForState(state, variant);
    updateGalleryHeroForState(state, variant);
    updateProductInventoryStatusForState(state, variant);
    updateAddToCartStateForState(state, variant);
    syncProductWishlistButtonForState(state, variant);
    syncProductCopyLinkButtonForState(state, variant);
  }

  function hasSelectedSizeForState(state) {
    return !!(state && state.sizeSelector && state.sizeSelector.querySelector('.variant-selector__option--size.active'));
  }

  function setSizeSelectorErrorForState(state, isInvalid) {
    if (!state || !state.sizeSelector) return;
    state.sizeSelector.classList.toggle('is-invalid', isInvalid);
    if (state.sizeSelectorError) {
      state.sizeSelectorError.setAttribute('aria-hidden', isInvalid ? 'false' : 'true');
    }
  }

  function syncProductWishlistButtonForState(state, variant) {
    var toggle = state.root.querySelector('[data-wishlist-product-page-toggle]');
    if (!toggle || !variant) return;
    var productData = state.productData || {};
    var imageData = state.galleryHeroImages[variant.id] || state.galleryDefaultHero || {};
    var color = productData.colorOptionIndex !== null && productData.colorOptionIndex !== undefined ? variant.options[productData.colorOptionIndex] : '';
    var hasSizeOption = productData.sizeOptionIndex !== null && productData.sizeOptionIndex !== undefined;
    var hasSelectorOption = productData.selectorOptionIndex !== null && productData.selectorOptionIndex !== undefined;
    var selectedOptions = Array.isArray(variant.options) ? variant.options.slice() : [];
    if (hasSizeOption && selectedOptions[productData.sizeOptionIndex]) {
      selectedOptions[productData.sizeOptionIndex] = '';
    }

    updateWishlistToggleDataset(toggle, {
      wishlistVariantId: String(variant.id),
      wishlistProductHandle: productData.handle || '',
      wishlistProductUrl: (productData.url || window.location.pathname) + '?variant=' + variant.id,
      wishlistProductTitle: productData.title || document.title,
      wishlistVariantTitle: variant.title || '',
      wishlistPrice: String(variant.price || 0),
      wishlistCompareAtPrice: String(variant.compare_at_price || 0),
      wishlistFeaturedImage: imageData.src || '',
      wishlistColor: color || '',
      wishlistSize: '',
      wishlistAvailable: variant.available ? 'true' : 'false',
      wishlistHasColorOption: productData.colorOptionIndex !== null && productData.colorOptionIndex !== undefined ? 'true' : 'false',
      wishlistColorOptionIndex: productData.colorOptionIndex !== null && productData.colorOptionIndex !== undefined ? String(productData.colorOptionIndex) : '',
      wishlistHasSizeOption: hasSizeOption ? 'true' : 'false',
      wishlistSizeOptionIndex: hasSizeOption ? String(productData.sizeOptionIndex) : '',
      wishlistHasSelectorOption: hasSelectorOption ? 'true' : 'false',
      wishlistSelectorOptionIndex: hasSelectorOption ? String(productData.selectorOptionIndex) : '',
      wishlistSelectorOptionName: productData.selectorOptionName || '',
      wishlistSelectedOptions: JSON.stringify(selectedOptions)
    });
  }

  function syncProductCopyLinkButtonForState(state, variant) {
    var button = state.root.querySelector('[data-copy-product-link]');
    if (!button || !variant) return;
    var productData = state.productData || {};
    button.dataset.copyUrl = productData.url || window.location.pathname;
    setCopyLinkButtonState(button, false);
  }

  Array.from(document.querySelectorAll('[data-product-component], .product-page')).forEach(function(root) {
    var state = getProductComponentState(root);
    if (!state) return;
    syncVariantStateForState(state);
    syncGalleryStatusForState(state);

    state.root.querySelectorAll('.variant-selector__option').forEach(function(btn) {
      if (btn.hasAttribute('data-tournament-event')) return;
      btn.addEventListener('click', function() {
        if (this.disabled || this.classList.contains('variant-selector__option--oos')) return;
        this.closest('.variant-selector__options')
          .querySelectorAll('.variant-selector__option')
          .forEach(function(button) { button.classList.remove('active'); });
        this.classList.add('active');
        if (this.classList.contains('variant-selector__option--size')) {
          setSizeSelectorErrorForState(state, false);
        }
        if (this.closest('.variant-selector') && this.dataset.optionLabel) {
          updateSelectedOptionLabelForState(state, this);
        }
        syncVariantStateForState(state);
      });
    });

    if (state.productGallery && state.productGalleryDots.length) {
      var galleryScrollTicking = false;

      state.productGallery.addEventListener('scroll', function() {
        if (galleryScrollTicking) return;
        galleryScrollTicking = true;
        window.requestAnimationFrame(function() {
          syncGalleryStatusForState(state);
          galleryScrollTicking = false;
        });
      });

      window.addEventListener('resize', function() {
        syncGalleryStatusForState(state);
      });
      observeGallerySlidesForState(state);
    }
  });

  /* ---------- Cart Quantity ---------- */
  document.querySelectorAll('.cart-item__qty button').forEach(btn => {
    btn.addEventListener('click', function() {
      const input = this.parentElement.querySelector('input');
      const lineIndex = parseInt(input.dataset.line);
      let val = parseInt(input.value) || 1;
      if (this.dataset.action === 'increase') val++;
      if (this.dataset.action === 'decrease') val--;
      if (val < 1) {
        const cartItem = this.closest('.cart-item');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: lineIndex, quantity: 0 })
        })
        .then(r => r.json())
        .then(cart => {
          cartItem.remove();
          updateCartCounts(cart.item_count);
          const subtotalEl = document.querySelector('.cart-totals__subtotal');
          if (subtotalEl) subtotalEl.textContent = 'Subtotal: ' + formatMoney(cart.total_price);
          renderCartLevelDiscounts(document.querySelector('[data-cart-level-discounts]'), cart);
        });
        return;
      }
      const cartItemEl = this.closest('.cart-item');
      const increaseBtn = cartItemEl.querySelector('[data-action="increase"]');
      if (this.dataset.action === 'decrease' && increaseBtn) increaseBtn.disabled = false;
      input.value = val;
      const priceEl = cartItemEl.querySelector('[data-cart-line-price]');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineIndex, quantity: val })
      })
      .then(r => r.json().then(data => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok || !data.items) {
          input.value = val - 1;
          if (increaseBtn) increaseBtn.disabled = true;
          return;
        }
        const item = data.items[lineIndex - 1];
        if (item && item.quantity < val) {
          input.value = item.quantity;
          if (increaseBtn) increaseBtn.disabled = true;
        }
        if (priceEl && item) {
          priceEl.dataset.unitPrice = String(item.price || priceEl.dataset.unitPrice || 0);
          priceEl.innerHTML = getCartLinePriceHtml(
            item.final_line_price || item.line_price,
            priceEl.dataset.unitCompareAtPrice,
            item.quantity,
            item.price,
            item.original_line_price,
            item.line_level_discount_allocations || item.discount_allocations
          );
        }
        const subtotalEl = document.querySelector('.cart-totals__subtotal');
        if (subtotalEl) subtotalEl.textContent = 'Subtotal: ' + formatMoney(data.total_price);
        renderCartLevelDiscounts(document.querySelector('[data-cart-level-discounts]'), data);
        updateCartCounts(data.item_count);
      });
    });
  });

  /* ---------- Scroll Fade-In ---------- */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-up');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));
  }

  /* ---------- Cart Drawer ---------- */
  var cartDrawer = document.getElementById('CartDrawer');
  var cartDrawerBody = document.getElementById('CartDrawerBody');
  var cartDrawerFooter = document.getElementById('CartDrawerFooter');
  var cartDrawerSubtotal = document.getElementById('CartDrawerSubtotal');
  var cartDrawerDiscounts = document.getElementById('CartDrawerDiscounts');
  var cartDrawerTitle = cartDrawer ? cartDrawer.querySelector('[data-cart-drawer-title]') : null;
  var cartDrawerTabs = cartDrawer ? Array.from(cartDrawer.querySelectorAll('[data-cart-drawer-tab-trigger]')) : [];
  var cartDrawerViews = cartDrawer ? Array.from(cartDrawer.querySelectorAll('[data-cart-drawer-view]')) : [];
  var cartDrawerWishlistPopup = document.getElementById('CartDrawerWishlistPopup');
  var cartDrawerWishlistPopupMessage = document.getElementById('CartDrawerWishlistPopupMessage');
  var cartDrawerWishlistPopupLink = document.getElementById('CartDrawerWishlistPopupLink');
  var cartDrawerWishlistPopupUndo = document.getElementById('CartDrawerWishlistPopupUndo');
  var wishlistPageToast = document.getElementById('WishlistPageToast');
  var wishlistPageToastMessage = document.getElementById('WishlistPageToastMessage');
  var wishlistPageToastLink = document.getElementById('WishlistPageToastLink');
  var wishlistPageToastUndo = document.getElementById('WishlistPageToastUndo');
  var browseWishlistToast = document.getElementById('BrowseWishlistToast');
  var browseWishlistToastMessage = document.getElementById('BrowseWishlistToastMessage');
  var browseWishlistToastLink = document.getElementById('BrowseWishlistToastLink');
  var browseWishlistToastUndo = document.getElementById('BrowseWishlistToastUndo');
  var productPageWishlistToast = document.getElementById('ProductPageWishlistToast');
  var productPageWishlistToastMessage = document.getElementById('ProductPageWishlistToastMessage');
  var productPageWishlistToastLink = document.getElementById('ProductPageWishlistToastLink');
  var productPageWishlistToastUndo = document.getElementById('ProductPageWishlistToastUndo');
  var cartQtyByVariant = {};
  var cartDrawerTrigger = null;
  var activeCartDrawerTab = 'bag';
  var pendingMaxWarning = 0;
  var lastRemovedWishlistItem = null;
  var cartDrawerTitles = {
    bag: document.body ? document.body.dataset.cartBagTitle || 'Your Bag' : 'Your Bag',
    wishlist: document.body ? document.body.dataset.cartWishlistTitle || 'Wishlist' : 'Wishlist'
  };

  // Populate cartQtyByVariant on page load for product page pre-flight guard
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      cart.items.forEach(function(item) {
        cartQtyByVariant[item.variant_id] = item.quantity;
      });
    });

  function refreshCartQuantities() {
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cartQtyByVariant = {};
        cart.items.forEach(function(item) {
          cartQtyByVariant[item.variant_id] = item.quantity;
        });
        return cart;
      })
      .catch(function() {
        return null;
      });
  }

  function normalizeLineItemProperties(properties) {
    var normalized = {};
    if (!properties || typeof properties !== 'object') return normalized;

    Object.keys(properties).forEach(function(key) {
      var value = properties[key];
      if (value == null) return;
      var normalizedValue = String(value).trim();
      if (!normalizedValue) return;
      normalized[String(key)] = normalizedValue;
    });

    return normalized;
  }

  function lineItemPropertiesEqual(first, second) {
    var firstNormalized = normalizeLineItemProperties(first);
    var secondNormalized = normalizeLineItemProperties(second);
    var firstKeys = Object.keys(firstNormalized);
    var secondKeys = Object.keys(secondNormalized);

    if (firstKeys.length !== secondKeys.length) return false;

    return firstKeys.every(function(key) {
      return secondNormalized[key] === firstNormalized[key];
    });
  }

  function getCartItemByVariant(cart, variantId, properties) {
    if (!cart || !Array.isArray(cart.items) || !variantId) return null;
    for (var index = 0; index < cart.items.length; index++) {
      var item = cart.items[index];
      if (item && item.variant_id === variantId && lineItemPropertiesEqual(item.properties, properties)) {
        return {
          item: item,
          line: index + 1
        };
      }
    }
    return null;
  }

  function getCartInventoryGuardResult(variantId, inventoryMeta) {
    var normalizedMeta = normalizeVariantInventoryMeta(inventoryMeta);
    if (!variantId || !normalizedMeta || !normalizedMeta.mgmt || normalizedMeta.policy !== 'deny' || normalizedMeta.qty <= 0) {
      return { blocked: false };
    }

    var inCart = cartQtyByVariant[variantId] || 0;
    return {
      blocked: inCart >= normalizedMeta.qty,
      in_cart: inCart,
      qty: normalizedMeta.qty
    };
  }

  function handleMaxInventoryReached(variantId) {
    pendingMaxWarning = variantId;
    fetchAndRenderCart();
    openCartDrawer('bag');
  }

  function getAddToCartErrorMessage(errorData) {
    if (!errorData || typeof errorData !== 'object') return '';
    return String(errorData.description || errorData.message || '').toLowerCase();
  }

  function isInventoryLimitErrorResponse(errorData) {
    var message = getAddToCartErrorMessage(errorData);
    if (!message) return false;
    if (message.indexOf('sold out') !== -1 || message.indexOf('unavailable') !== -1) return false;
    return message.indexOf('in your cart') !== -1
      || message.indexOf('remaining') !== -1
      || message.indexOf("can't add") !== -1
      || message.indexOf('cannot add') !== -1
      || message.indexOf('only') !== -1
      || message.indexOf('available') !== -1;
  }

  function getProductVariantInventoryMeta(productData, variantId) {
    if (!productData || !Array.isArray(productData.variants) || !variantId) return null;
    var matchingVariant = productData.variants.find(function(variant) {
      return parseWishlistInt(variant && variant.id) === variantId;
    });
    return normalizeVariantInventoryMeta(matchingVariant);
  }

  function resolveWishlistVariantInventoryMeta(wishlistItem, resolvedVariant, variantId) {
    var inventoryMeta = normalizeVariantInventoryMeta(resolvedVariant);
    if (inventoryMeta && inventoryMeta.mgmt && inventoryMeta.policy) {
      return Promise.resolve(inventoryMeta);
    }
    if (!wishlistItem || !wishlistItem.product_handle) {
      return Promise.resolve(inventoryMeta);
    }
    return fetchWishlistProductData(wishlistItem.product_handle)
      .then(function(productData) {
        return getProductVariantInventoryMeta(productData, variantId) || inventoryMeta;
      });
  }

  function syncCartQuantitiesFromCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    cartQtyByVariant = {};
    cart.items.forEach(function(item) {
      cartQtyByVariant[item.variant_id] = item.quantity;
    });
  }

  function fetchCartJson() {
    return fetch('/cart.js').then(function(r) { return r.json(); });
  }

  function refreshCartState() {
    return fetchCartJson().then(function(cart) {
      syncCartQuantitiesFromCart(cart);
      updateCartCounts(cart.item_count);
      return cart;
    });
  }

  function addWishlistVariantToCart(variantId, cart, properties) {
    var normalizedProperties = normalizeLineItemProperties(properties);
    var cartItemMatch = getCartItemByVariant(cart, variantId, normalizedProperties);
    if (cartItemMatch) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: cartItemMatch.line, quantity: cartItemMatch.item.quantity + 1 })
      })
      .then(function(r) {
        return r.json().then(function(data) { return { ok: r.ok, data: data, expectedQuantity: cartItemMatch.item.quantity + 1 }; });
      });
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: Object.keys(normalizedProperties).length ? normalizedProperties : undefined
      })
    })
    .then(function(r) {
      return r.json().then(function(data) { return { ok: r.ok, data: data, expectedQuantity: 1 }; });
    });
  }

  function setCartDrawerTab(tabName) {
    if (!cartDrawer) return;
    activeCartDrawerTab = tabName === 'wishlist' ? 'wishlist' : 'bag';
    cartDrawer.classList.toggle('is-bag-view', activeCartDrawerTab === 'bag');
    cartDrawer.classList.toggle('is-wishlist-view', activeCartDrawerTab === 'wishlist');
    if (cartDrawerTitle) {
      cartDrawerTitle.textContent = cartDrawerTitles[activeCartDrawerTab];
    }

    cartDrawerTabs.forEach(function(tab) {
      var isActive = tab.dataset.cartDrawerTarget === activeCartDrawerTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    cartDrawerViews.forEach(function(view) {
      var isActive = view.dataset.cartDrawerView === activeCartDrawerTab;
      view.classList.toggle('is-active', isActive);
      view.hidden = !isActive;
      view.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }

  function openCartDrawer(tabName) {
    if (!cartDrawer) return;
    setCartDrawerTab(tabName);
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = cartDrawer.querySelector('.cart-drawer__close');
    if (closeBtn) setTimeout(function() { closeBtn.focus(); }, 50);
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (shouldRestoreBodyScroll()) document.body.style.overflow = '';
    if (cartDrawerTrigger) {
      cartDrawerTrigger.focus();
      cartDrawerTrigger = null;
    }
  }

  if (cartDrawerWishlistPopupLink) {
    cartDrawerWishlistPopupLink.addEventListener('click', function(event) {
      var currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
      var wishlistPath = this.pathname.replace(/\/+$/, '') || '/';
      if (currentPath === wishlistPath) {
        event.preventDefault();
        closeCartDrawer();
      }
    });
  }

  if (cartDrawerWishlistPopupUndo) {
    cartDrawerWishlistPopupUndo.addEventListener('click', function() {
      if (!lastRemovedWishlistItem) return;
      setHeaderWishlistIndicatorVisible(false);
      addWishlistItem(lastRemovedWishlistItem);
      lastRemovedWishlistItem = null;
      showCartDrawerWishlistPopup('Item added to your wishlist', { showLink: true });
    });
  }

  if (wishlistPageToastUndo) {
    wishlistPageToastUndo.addEventListener('click', function() {
      if (!lastRemovedWishlistItem) return;
      setHeaderWishlistIndicatorVisible(false);
      addWishlistItem(lastRemovedWishlistItem);
      lastRemovedWishlistItem = null;
      showWishlistPageToast('Item added to your wishlist', { showLink: true });
    });
  }

  if (wishlistPageToastLink) {
    wishlistPageToastLink.addEventListener('click', function(event) {
      event.preventDefault();
    });
  }

  if (browseWishlistToastUndo) {
    browseWishlistToastUndo.addEventListener('click', function() {
      if (!lastRemovedWishlistItem) return;
      setHeaderWishlistIndicatorVisible(false);
      addWishlistItem(lastRemovedWishlistItem);
      lastRemovedWishlistItem = null;
      showBrowseWishlistToast('Item added to your wishlist', { showLink: true });
    });
  }

  if (productPageWishlistToastUndo) {
    productPageWishlistToastUndo.addEventListener('click', function() {
      if (!lastRemovedWishlistItem) return;
      setHeaderWishlistIndicatorVisible(false);
      addWishlistItem(lastRemovedWishlistItem);
      lastRemovedWishlistItem = null;
      showProductPageWishlistToast('Item added to your wishlist', { showLink: true });
    });
  }

  function showCartDrawerWishlistPopup(message, options) {
    if (!cartDrawerWishlistPopup || !cartDrawerWishlistPopupMessage || !message) return;
    var settings = options || {};
    window.clearTimeout(cartDrawerWishlistPopupTimeout);
    cartDrawerWishlistPopupMessage.textContent = message;
    if (cartDrawerWishlistPopupLink) {
      cartDrawerWishlistPopupLink.hidden = !settings.showLink;
    }
    if (cartDrawerWishlistPopupUndo) {
      cartDrawerWishlistPopupUndo.hidden = !settings.showUndo;
    }
    cartDrawerWishlistPopup.classList.add('is-visible');
    cartDrawerWishlistPopup.setAttribute('aria-hidden', 'false');
    cartDrawerWishlistPopupTimeout = window.setTimeout(function() {
      cartDrawerWishlistPopup.classList.remove('is-visible');
      cartDrawerWishlistPopup.setAttribute('aria-hidden', 'true');
    }, CART_DRAWER_WISHLIST_POPUP_MS);
  }

  function showWishlistPageToast(message, options) {
    if (!wishlistPageToast || !wishlistPageToastMessage || !message) return;
    var settings = options || {};
    window.clearTimeout(wishlistPageToastTimeout);
    wishlistPageToastMessage.textContent = message;
    if (wishlistPageToastLink) {
      wishlistPageToastLink.hidden = !settings.showLink;
    }
    if (wishlistPageToastUndo) {
      wishlistPageToastUndo.hidden = !settings.showUndo;
    }
    wishlistPageToast.classList.add('is-visible');
    wishlistPageToast.setAttribute('aria-hidden', 'false');
    wishlistPageToastTimeout = window.setTimeout(function() {
      wishlistPageToast.classList.remove('is-visible');
      wishlistPageToast.setAttribute('aria-hidden', 'true');
    }, CART_DRAWER_WISHLIST_POPUP_MS);
  }

  function showBrowseWishlistToast(message, options) {
    if (!browseWishlistToast || !browseWishlistToastMessage || !message) return;
    var settings = options || {};
    window.clearTimeout(wishlistPageToastTimeout);
    browseWishlistToastMessage.textContent = message;
    if (browseWishlistToastLink) {
      browseWishlistToastLink.hidden = !settings.showLink;
    }
    if (browseWishlistToastUndo) {
      browseWishlistToastUndo.hidden = !settings.showUndo;
    }
    browseWishlistToast.classList.add('is-visible');
    browseWishlistToast.setAttribute('aria-hidden', 'false');
    wishlistPageToastTimeout = window.setTimeout(function() {
      browseWishlistToast.classList.remove('is-visible');
      browseWishlistToast.setAttribute('aria-hidden', 'true');
    }, CART_DRAWER_WISHLIST_POPUP_MS);
  }

  function showProductPageWishlistToast(message, options) {
    if (!productPageWishlistToast || !productPageWishlistToastMessage || !message) return;
    var settings = options || {};
    window.clearTimeout(wishlistPageToastTimeout);
    productPageWishlistToastMessage.textContent = message;
    if (productPageWishlistToastLink) {
      productPageWishlistToastLink.hidden = !settings.showLink;
    }
    if (productPageWishlistToastUndo) {
      productPageWishlistToastUndo.hidden = !settings.showUndo;
    }
    productPageWishlistToast.classList.add('is-visible');
    productPageWishlistToast.setAttribute('aria-hidden', 'false');
    wishlistPageToastTimeout = window.setTimeout(function() {
      productPageWishlistToast.classList.remove('is-visible');
      productPageWishlistToast.setAttribute('aria-hidden', 'true');
    }, CART_DRAWER_WISHLIST_POPUP_MS);
  }

  setCartDrawerTab('bag');

  function renderCartDrawerBody(sectionHtml, cart) {
    if (!cartDrawerBody || !sectionHtml || !cart) return;
    cartDrawerBody.innerHTML = sectionHtml;
    if (pendingMaxWarning) {
      var warnItem = cartDrawerBody.querySelector('.cart-item[data-variant-id="' + pendingMaxWarning + '"]');
      if (warnItem) {
        var msg = document.createElement('p');
        msg.className = 'cart-item__max-msg';
        msg.textContent = 'No more available in stock';
        warnItem.querySelector('.cart-item__details').appendChild(msg);
      }
      pendingMaxWarning = 0;
    }
    if (cartDrawerFooter) cartDrawerFooter.style.display = cart.item_count > 0 ? '' : 'none';
    if (cartDrawerSubtotal) cartDrawerSubtotal.textContent = formatMoney(cart.total_price);
    renderCartLevelDiscounts(cartDrawerDiscounts, cart);
    updateCartWishlistIndicators();
  }

  function fetchCartDrawerSectionHtml() {
    return fetch('/?sections=cart-drawer')
      .then(function(r) {
        if (!r.ok) {
          throw new Error('Cart drawer section render failed with status ' + r.status);
        }
        return r.json();
      })
      .then(function(sections) {
        return sections && sections['cart-drawer'] ? sections['cart-drawer'] : '';
      });
  }

  function fetchAndRenderCart() {
    if (cartDrawerBody) cartDrawerBody.classList.add('is-loading');
    return refreshCartState().then(function(cart) {
      announceCartUpdate('Cart updated. ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ' in your bag.');
      if (!cartDrawerBody) return { cart: cart, rendered: false };
      return fetchCartDrawerSectionHtml().then(function(sectionHtml) {
        renderCartDrawerBody(sectionHtml, cart);
        return { cart: cart, rendered: true };
      }).catch(function() {
        return { cart: cart, rendered: false };
      });
    }).catch(function() {
      return { cart: null, rendered: false };
    }).then(function(result) {
      if (cartDrawerBody) cartDrawerBody.classList.remove('is-loading');
      return result;
    });
  }

  function drawerChangeQuantity(lineIndex, newQty) {
    if (!cartDrawerBody) return;
    cartDrawerBody.classList.add('is-loading');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: newQty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      cartQtyByVariant = {};
      cart.items.forEach(function(item) {
        cartQtyByVariant[item.variant_id] = item.quantity;
      });
      fetchAndRenderCart();
    })
    .catch(function() { cartDrawerBody.classList.remove('is-loading'); });
  }

  if (cartDrawerBody) {
    cartDrawerBody.addEventListener('click', function(e) {
      var qtyBtn = e.target.closest('.cart-item__qty button');
      if (qtyBtn && !qtyBtn.disabled) {
        var lineIndex = parseInt(qtyBtn.dataset.line);
        var input = qtyBtn.parentElement.querySelector('input');
        var val = parseInt(input.value) || 1;
        if (qtyBtn.dataset.action === 'increase') val++;
        if (qtyBtn.dataset.action === 'decrease') val--;
        drawerChangeQuantity(lineIndex, Math.max(0, val));
        return;
      }
    });
  }

  document.querySelectorAll('.cart-drawer-trigger').forEach(function(btn) {
    btn.addEventListener('click', function() {
      cartDrawerTrigger = this;
      var target = this.dataset.cartDrawerTarget === 'wishlist' ? 'wishlist' : 'bag';
      if (target === 'bag') {
        fetchAndRenderCart();
      } else {
        renderWishlistDrawer(loadWishlist());
      }
      openCartDrawer(target);
    });
  });

  if (cartDrawer) {
    var drawerCloseBtn = cartDrawer.querySelector('.cart-drawer__close');
    var drawerOverlay = cartDrawer.querySelector('.cart-drawer__overlay');
    cartDrawerTabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = tab.dataset.cartDrawerTarget === 'wishlist' ? 'wishlist' : 'bag';
        setCartDrawerTab(target);
        if (target === 'bag') {
          fetchAndRenderCart();
        } else {
          renderWishlistDrawer(loadWishlist());
        }
      });
    });
    if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeCartDrawer);
    if (drawerOverlay) drawerOverlay.addEventListener('click', closeCartDrawer);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) closeCartDrawer();
    });
  }

  function setAddToCartButtonState(button, label, disabled, isLoading, isSuccess) {
    if (!button) return;
    var labelEl = button.querySelector('.add-to-cart-btn__label');
    if (labelEl) {
      labelEl.textContent = label;
    } else {
      button.textContent = label;
    }
    button.disabled = !!disabled;
    button.classList.toggle('is-loading', !!isLoading);
    button.classList.toggle('is-success', !!isSuccess);
  }

  function buildAddToCartPayload(form) {
    var formData = new FormData(form);
    var payload = {
      id: parseInt(formData.get('id'), 10),
      quantity: parseInt(formData.get('quantity'), 10) || 1
    };
    var properties = {};

    formData.forEach(function(value, key) {
      if (typeof key !== 'string' || key.indexOf('properties[') !== 0 || key.charAt(key.length - 1) !== ']') return;
      var propertyName = key.slice(11, -1);
      if (!propertyName || value == null || value === '') return;
      properties[propertyName] = value;
    });

    if (Object.keys(properties).length) {
      payload.properties = properties;
    }

    return payload;
  }

  function isTournamentRegistrationForm(form) {
    return !!(form && form.closest('.product-page--tournament'));
  }

  function getTournamentEventCards(form) {
    if (!form) return [];
    return Array.from(form.querySelectorAll('[data-tournament-event]'));
  }

  function setTournamentEventError(form, message) {
    var errorEl = form ? form.querySelector('[data-tournament-event-error]') : null;
    if (!errorEl) return;
    errorEl.textContent = message || '';
    errorEl.hidden = !message;
  }

  function setTournamentEventSelected(card, isSelected) {
    if (!card || card.dataset.eventAvailable !== 'true') return;
    var toggle = card.querySelector('[data-tournament-event-toggle]');

    card.classList.toggle('active', !!isSelected);
    card.classList.toggle('is-selected', !!isSelected);

    if (toggle) {
      toggle.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    }
  }

  function getTournamentPartnerSectionsRoot(form) {
    return form ? form.querySelector('[data-tournament-partner-sections]') : null;
  }

  function getTournamentPartnerSectionsList(form) {
    return form ? form.querySelector('[data-tournament-partner-sections-list]') : null;
  }

  function getTournamentPartnerValues(form) {
    var values = {};
    if (!form) return values;

    Array.from(form.querySelectorAll('[data-tournament-partner-section]')).forEach(function(section) {
      var variantId = section.dataset.variantId;
      if (!variantId) return;
      values[variantId] = {};
      Array.from(section.querySelectorAll('[data-tournament-partner-input]')).forEach(function(input) {
        values[variantId][input.dataset.tournamentPartnerInput] = input.value;
      });
    });

    return values;
  }

  function getTournamentPartnerSectionForVariant(form, variantId) {
    var variantKey = String(variantId || '');
    return getTournamentPartnerSectionsList(form)
      ? Array.from(form.querySelectorAll('[data-tournament-partner-section]')).find(function(section) {
          return section.dataset.variantId === variantKey;
        })
      : null;
  }

  function getTournamentPartnerFieldHtml(variantId, eventTitle, fieldName, label, type, autocomplete, value) {
    var inputId = 'TournamentPartner-' + variantId + '-' + fieldName;
    return (
      '<div class="product-line-properties__field tournament-partner-card__field tournament-partner-card__field--' + escapeHtml(fieldName) + '">' +
        '<label class="product-line-properties__label" for="' + escapeHtml(inputId) + '">' +
          escapeHtml(label) + ' <span class="product-line-properties__required" aria-hidden="true">*</span>' +
        '</label>' +
        '<input' +
          ' id="' + escapeHtml(inputId) + '"' +
          ' class="product-line-properties__input"' +
          ' type="' + escapeHtml(type) + '"' +
          ' autocomplete="' + escapeHtml(autocomplete) + '"' +
          ' data-tournament-partner-input="' + escapeHtml(fieldName) + '"' +
          ' data-tournament-partner-event-title="' + escapeHtml(eventTitle) + '"' +
          ' value="' + escapeHtml(value || '') + '"' +
          ' required' +
        '>' +
      '</div>'
    );
  }

  function updateTournamentPartnerSections(form) {
    var root = getTournamentPartnerSectionsRoot(form);
    var list = getTournamentPartnerSectionsList(form);
    if (!root || !list) return;

    var existingValues = getTournamentPartnerValues(form);
    var selectedCards = getTournamentEventCards(form).filter(function(card) {
      return card.classList.contains('is-selected') && card.dataset.eventAvailable === 'true';
    });

    root.hidden = !selectedCards.length;
    if (!selectedCards.length) {
      list.innerHTML = '';
      return;
    }

    list.innerHTML = selectedCards.map(function(card) {
      var variantId = card.dataset.variantId || '';
      var eventTitle = card.dataset.eventTitle || 'Selected event';
      var values = existingValues[variantId] || {};

      return (
        '<article class="tournament-partner-card" data-tournament-partner-section data-variant-id="' + escapeHtml(variantId) + '">' +
          '<h4 class="tournament-registration__title tournament-registration__title--section tournament-partner-card__title">' + escapeHtml(eventTitle) + '</h4>' +
          '<div class="product-line-properties tournament-registration__fields tournament-partner-card__fields" aria-label="' + escapeHtml(eventTitle + ' partner details') + '">' +
            getTournamentPartnerFieldHtml(variantId, eventTitle, 'first_name', 'Partner First Name', 'text', 'given-name', values.first_name) +
            getTournamentPartnerFieldHtml(variantId, eventTitle, 'last_name', 'Partner Last Name', 'text', 'family-name', values.last_name) +
            getTournamentPartnerFieldHtml(variantId, eventTitle, 'email', 'Partner Email', 'email', 'email', values.email) +
            getTournamentPartnerFieldHtml(variantId, eventTitle, 'phone', 'Partner Phone number', 'tel', 'tel', values.phone) +
            getTournamentPartnerFieldHtml(variantId, eventTitle, 'dupr', 'Partner DUPR ID', 'text', 'off', values.dupr) +
          '</div>' +
        '</article>'
      );
    }).join('');
  }

  function initializeTournamentEventSelection(form) {
    if (!isTournamentRegistrationForm(form)) return;
    getTournamentEventCards(form).forEach(function(card) {
      setTournamentEventSelected(card, card.classList.contains('is-selected') || card.classList.contains('active'));
    });
    updateTournamentPartnerSections(form);

    form.addEventListener('click', function(e) {
      var toggle = e.target.closest('[data-tournament-event-toggle]');
      if (!toggle || !form.contains(toggle)) return;
      e.preventDefault();
      var card = toggle.closest('[data-tournament-event]');
      if (!card || toggle.disabled || card.dataset.eventAvailable !== 'true') return;
      setTournamentEventError(form, '');
      setTournamentEventSelected(card, !card.classList.contains('is-selected'));
      updateTournamentPartnerSections(form);
    });
  }

  function getTournamentSharedProperties(form) {
    var properties = {};
    var formData = new FormData(form);

    formData.forEach(function(value, key) {
      if (typeof key !== 'string' || key.indexOf('properties[') !== 0 || key.charAt(key.length - 1) !== ']') return;
      var propertyName = key.slice(11, -1);
      var normalizedValue = String(value || '').trim();
      if (!propertyName || !normalizedValue) return;
      properties[propertyName] = normalizedValue;
    });

    return properties;
  }

  function buildTournamentAddToCartPayload(form, componentVariants) {
    var selectedCards = getTournamentEventCards(form).filter(function(card) {
      return card.classList.contains('is-selected') && card.dataset.eventAvailable === 'true';
    });

    if (!selectedCards.length) {
      setTournamentEventError(form, 'Select at least one event.');
      var firstToggle = form.querySelector('[data-tournament-event-toggle]:not([disabled])');
      if (firstToggle) firstToggle.focus();
      return false;
    }

    setTournamentEventError(form, '');

    var sharedProperties = getTournamentSharedProperties(form);
    var variantsList = Array.isArray(componentVariants) ? componentVariants : [];
    var registrationStamp = Date.now().toString(36);
    var items = [];

    for (var index = 0; index < selectedCards.length; index++) {
      var card = selectedCards[index];
      var variantId = parseInt(card.dataset.variantId, 10);
      var selectedVariant = variantsList.find(function(variant) { return variant.id === variantId; });
      var partnerSection = getTournamentPartnerSectionForVariant(form, variantId);
      var partnerFirstNameInput = partnerSection ? partnerSection.querySelector('[data-tournament-partner-input="first_name"]') : null;
      var partnerLastNameInput = partnerSection ? partnerSection.querySelector('[data-tournament-partner-input="last_name"]') : null;
      var partnerEmailInput = partnerSection ? partnerSection.querySelector('[data-tournament-partner-input="email"]') : null;
      var partnerPhoneInput = partnerSection ? partnerSection.querySelector('[data-tournament-partner-input="phone"]') : null;
      var partnerDuprInput = partnerSection ? partnerSection.querySelector('[data-tournament-partner-input="dupr"]') : null;
      var partnerFirstName = partnerFirstNameInput ? String(partnerFirstNameInput.value || '').trim() : '';
      var partnerLastName = partnerLastNameInput ? String(partnerLastNameInput.value || '').trim() : '';
      var partnerEmail = partnerEmailInput ? String(partnerEmailInput.value || '').trim() : '';
      var partnerPhone = partnerPhoneInput ? String(partnerPhoneInput.value || '').trim() : '';
      var partnerDupr = partnerDuprInput ? String(partnerDuprInput.value || '').trim() : '';

      if (!variantId || !selectedVariant || !selectedVariant.available) {
        setTournamentEventError(form, 'One of the selected events is no longer available.');
        return false;
      }

      if (!partnerFirstName || !partnerLastName || !partnerEmail || !partnerPhone || !partnerDupr) {
        var firstInvalidInput = partnerSection ? partnerSection.querySelector('[data-tournament-partner-input]:invalid') : null;
        if (firstInvalidInput && typeof firstInvalidInput.reportValidity === 'function') {
          firstInvalidInput.reportValidity();
        }
        return false;
      }

      var properties = {};
      Object.keys(sharedProperties).forEach(function(key) {
        properties[key] = sharedProperties[key];
      });
      properties.Event = card.dataset.eventTitle || selectedVariant.title || 'Tournament event';
      properties['Partner First Name'] = partnerFirstName;
      properties['Partner Last Name'] = partnerLastName;
      properties['Partner Email'] = partnerEmail;
      properties['Partner Phone number'] = partnerPhone;
      properties['Partner DUPR ID'] = partnerDupr;
      properties._registration_key = [
        'tournament',
        variantId,
        registrationStamp,
        index + 1
      ].join('-');

      items.push({
        id: variantId,
        quantity: 1,
        properties: properties
      });
    }

    return { items: items };
  }

  document.querySelectorAll('form[action="/cart/add"]').forEach(function(addToCartForm) {
    var addToCartSubmitBtn = addToCartForm.querySelector('.add-to-cart-btn');
    initializeTournamentEventSelection(addToCartForm);

    addToCartForm.addEventListener('submit', function(e) {
      e.preventDefault();
      if (typeof addToCartForm.reportValidity === 'function' && !addToCartForm.reportValidity()) {
        return;
      }
      var productState = getProductComponentState(getProductComponentRoot(addToCartForm));
      var payload = buildAddToCartPayload(addToCartForm);
      var variantId = payload.id;
      var addLabel = getAddToCartButtonLabel(addToCartSubmitBtn, 'add', 'Add to Bag');
      var loadingLabel = getAddToCartButtonLabel(addToCartSubmitBtn, 'loading', addLabel);
      var successLabel = getAddToCartButtonLabel(addToCartSubmitBtn, 'success', 'Added');
      var soldOutLabel = getAddToCartButtonLabel(addToCartSubmitBtn, 'soldOut', 'Sold Out');
      if (productState && productState.sizeSelector && !hasSelectedSizeForState(productState)) {
        setSizeSelectorErrorForState(productState, true);
        return;
      }
      var isTournamentRegistration = isTournamentRegistrationForm(addToCartForm);
      var componentVariants = productState ? productState.variants : variants;

      if (isTournamentRegistration) {
        payload = buildTournamentAddToCartPayload(addToCartForm, componentVariants);
        if (!payload) return;
        variantId = payload.items && payload.items[0] ? payload.items[0].id : null;
      }

      if (!variantId) return;
      var selectedVariant = componentVariants.find(function(variant) { return variant.id === variantId; });
      if (!selectedVariant || !selectedVariant.available) {
        setAddToCartButtonState(addToCartSubmitBtn, soldOutLabel, true, false, false);
        return;
      }

      var componentInventory = productState ? productState.productInventory : window.productInventory;
      var inventoryGuard = getCartInventoryGuardResult(variantId, componentInventory && componentInventory[variantId]);
      if (!isTournamentRegistration && inventoryGuard.blocked) {
        handleMaxInventoryReached(variantId);
        return;
      }

      setAddToCartButtonState(addToCartSubmitBtn, loadingLabel, true, true, false);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(r) {
        return r.json().then(function(data) { return { ok: r.ok, data: data }; });
      })
      .then(function(result) {
        if (!result.ok) {
          setAddToCartButtonState(addToCartSubmitBtn, addLabel, false, false, false);
          if (isTournamentRegistration) {
            window.alert(result.data && (result.data.description || result.data.message) ? result.data.description || result.data.message : 'Unable to add this registration to cart.');
            return;
          }
          handleMaxInventoryReached(variantId);
          return;
        }
        setAddToCartButtonState(addToCartSubmitBtn, successLabel, true, false, true);
        setTimeout(function() { setAddToCartButtonState(addToCartSubmitBtn, addLabel, false, false, false); }, 1500);
        fetchAndRenderCart().then(function() {
          openCartDrawer('bag');
        });
      })
      .catch(function() {
        setAddToCartButtonState(addToCartSubmitBtn, addLabel, false, false, false);
      });
    });
  });

  /* ============================================================
     COLLECTION PAGE — Filter, Sort, Load More, Swatches
     ============================================================ */

  /* ---------- Filter Drawer (mobile) ---------- */
  var filterDrawer = document.getElementById('FilterDrawer');
  var collectionAjaxRoot = document.getElementById('CollectionAjaxRoot');
  var collectionToolbar = document.querySelector('.collection-toolbar');
  var collectionBaseUrl = collectionToolbar ? collectionToolbar.dataset.collectionUrl : window.location.pathname;
  var activeCollectionRequestId = 0;

  function syncCollectionReferences() {
    collectionAjaxRoot = document.getElementById('CollectionAjaxRoot');
    filterDrawer = document.getElementById('FilterDrawer');
    collectionToolbar = document.querySelector('.collection-toolbar');
    collectionBaseUrl = collectionToolbar ? collectionToolbar.dataset.collectionUrl : window.location.pathname;
  }

  function openFilterDrawer() {
    syncCollectionReferences();
    if (!filterDrawer) return;
    filterDrawer.classList.add('is-open');
    filterDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = filterDrawer.querySelector('.filter-drawer__close');
    if (closeBtn) setTimeout(function() { closeBtn.focus(); }, 50);
  }

  function closeFilterDrawer() {
    syncCollectionReferences();
    if (!filterDrawer) return;
    filterDrawer.classList.remove('is-open');
    filterDrawer.setAttribute('aria-hidden', 'true');
    var cartOpen = cartDrawer && cartDrawer.classList.contains('is-open');
    var searchOverlay = document.getElementById('SearchOverlay');
    var searchOpen = searchOverlay && searchOverlay.classList.contains('is-open');
    if (!cartOpen && !searchOpen) document.body.style.overflow = '';
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('.js-filter-toggle')) {
      e.preventDefault();
      openFilterDrawer();
    }
  });

  document.addEventListener('click', function(e) {
    if (e.target.closest('.js-filter-drawer-close')) {
      e.preventDefault();
      closeFilterDrawer();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && filterDrawer && filterDrawer.classList.contains('is-open')) {
      closeFilterDrawer();
    }
  });

  /* ---------- Collapsible Filter Sections ---------- */
  function getFilterSectionState(root) {
    var state = {};
    (root || document).querySelectorAll('.js-filter-toggle-section').forEach(function(toggle) {
      var section = toggle.closest('.filter-section');
      var key = (toggle.textContent || '').replace(/\s+/g, ' ').trim();
      if (!section || !key) return;
      var isOpen = !section.classList.contains('is-collapsed');
      state[key] = Boolean(state[key]) || isOpen;
    });
    return state;
  }

  function applyFilterSectionState(root, state) {
    if (!state) return;
    root.querySelectorAll('.js-filter-toggle-section').forEach(function(toggle) {
      var section = toggle.closest('.filter-section');
      var body = section && section.querySelector('.filter-section__body');
      var chevron = section && section.querySelector('.filter-section__chevron');
      var key = (toggle.textContent || '').replace(/\s+/g, ' ').trim();
      if (!section || !body || !key || typeof state[key] === 'undefined') return;

      body.style.transition = 'none';
      if (chevron) {
        chevron.style.transition = 'none';
      }

      if (state[key]) {
        section.classList.remove('is-collapsed');
        body.style.maxHeight = body.scrollHeight + 'px';
        toggle.setAttribute('aria-expanded', 'true');
      } else {
        section.classList.add('is-collapsed');
        body.style.maxHeight = '0';
        toggle.setAttribute('aria-expanded', 'false');
      }

      requestAnimationFrame(function() {
        body.style.transition = '';
        if (chevron) {
          chevron.style.transition = '';
        }
      });
    });
  }

  function initFilterSections(root, savedState) {
    root = root || document;
    root.querySelectorAll('.js-filter-toggle-section').forEach(function(toggle) {
      if (toggle.dataset.filterInit) return;
      toggle.dataset.filterInit = '1';
      var section = toggle.closest('.filter-section');
      var body = section && section.querySelector('.filter-section__body');
      if (!body) return;

      // Set initial max-height so CSS transition works
      if (section.classList.contains('is-collapsed')) {
        body.style.maxHeight = '0';
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        body.style.maxHeight = body.scrollHeight + 'px';
        toggle.setAttribute('aria-expanded', 'true');
      }

      toggle.addEventListener('click', function() {
        var isCollapsed = section.classList.contains('is-collapsed');
        if (isCollapsed) {
          section.classList.remove('is-collapsed');
          body.style.maxHeight = body.scrollHeight + 'px';
          toggle.setAttribute('aria-expanded', 'true');
        } else {
          body.style.maxHeight = body.scrollHeight + 'px';
          requestAnimationFrame(function() {
            section.classList.add('is-collapsed');
            body.style.maxHeight = '0';
          });
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });

    applyFilterSectionState(root, savedState);
  }
  initFilterSections(document);

  function setCollectionLoadingState(isLoading) {
    if (!collectionAjaxRoot) return;
    collectionAjaxRoot.classList.toggle('is-loading', !!isLoading);
    collectionAjaxRoot.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function normalizeColorFilterValue(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function enhanceCollectionContent(root, savedFilterState) {
    if (!root) return;
    syncCollectionReferences();
    initFilterSections(root, savedFilterState);
    syncProductCardsToActiveCollectionColor(root);
    publishWishlistUpdate();
    initializeProductCardQuickAdd(root);
  }

  function fetchCollectionMarkup(url) {
    return fetch(url, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function(response) {
      if (!response.ok) throw new Error('Collection request failed');
      return response.text();
    });
  }

  function replaceCollectionContent(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var nextCollectionRoot = doc.getElementById('CollectionAjaxRoot');
    var currentCollectionRoot = document.getElementById('CollectionAjaxRoot');
    var savedFilterState = getFilterSectionState(currentCollectionRoot);

    if (!nextCollectionRoot || !currentCollectionRoot) {
      throw new Error('Missing collection AJAX root');
    }

    currentCollectionRoot.replaceWith(nextCollectionRoot);
    enhanceCollectionContent(nextCollectionRoot, savedFilterState);
    return nextCollectionRoot;
  }

  function navigateCollection(url, options) {
    options = options || {};
    syncCollectionReferences();
    if (!collectionAjaxRoot) {
      window.location.href = url;
      return Promise.resolve();
    }

    activeCollectionRequestId += 1;
    var requestId = activeCollectionRequestId;
    setCollectionLoadingState(true);

    return fetchCollectionMarkup(url)
      .then(function(html) {
        if (requestId !== activeCollectionRequestId) return;

        if (options.updateHistory) {
          history.pushState({ collectionUrl: url }, '', url);
        }

        replaceCollectionContent(html);

        if (options.closeDrawer) {
          closeFilterDrawer();
        }
      })
      .catch(function() {
        if (requestId !== activeCollectionRequestId) return;
        window.location.href = url;
      })
      .finally(function() {
        if (requestId !== activeCollectionRequestId) return;
        setCollectionLoadingState(false);
      });
  }

  /* ---------- Collection AJAX Filters / Sort ---------- */
  document.addEventListener('click', function(e) {
    var collectionLink = e.target.closest('[data-collection-link]');
    if (!collectionLink || !collectionAjaxRoot) return;
    if (collectionLink.classList.contains('is-disabled')) {
      e.preventDefault();
      return;
    }

    var nextUrl = collectionLink.getAttribute('href');
    if (!nextUrl) return;

    e.preventDefault();
    navigateCollection(nextUrl, {
      updateHistory: true,
      closeDrawer: !!collectionLink.closest('#FilterDrawer')
    });
  });

  document.addEventListener('click', function(e) {
    var sortButton = e.target.closest('[data-collection-sort]');
    if (!sortButton || !collectionAjaxRoot) return;

    e.preventDefault();
    var sortValue = sortButton.dataset.collectionSort;
    if (!sortValue) return;

    var url = new URL(window.location.href);
    if (sortButton.classList.contains('filter-option--active')) {
      url.searchParams.delete('sort_by');
    } else {
      url.searchParams.set('sort_by', sortValue);
    }
    url.searchParams.delete('page');
    var nextUrl = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '');
    navigateCollection(nextUrl, {
      updateHistory: true,
      closeDrawer: !!sortButton.closest('#FilterDrawer')
    });
  });

  window.addEventListener('popstate', function() {
    if (!document.getElementById('CollectionAjaxRoot')) return;
    navigateCollection(window.location.href, { updateHistory: false });
  });

  /* ---------- Load More ---------- */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.js-load-more');
    if (!btn || btn.classList.contains('is-loading')) return;

    var nextUrl = btn.dataset.nextUrl;
    if (!nextUrl) return;

    btn.classList.add('is-loading');
    btn.textContent = 'Loading...';

    fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newGrid = doc.getElementById('ProductGrid');
        var currentGrid = document.getElementById('ProductGrid');
        if (newGrid && currentGrid) {
          Array.from(newGrid.children).forEach(function(card) {
            currentGrid.appendChild(card);
          });
          publishWishlistUpdate();
          initializeProductCardQuickAdd(currentGrid);
        }

        var loadMoreWrap = document.getElementById('LoadMoreWrap');
        var newLoadMore = doc.querySelector('.js-load-more');
        if (newLoadMore && newLoadMore.dataset.nextUrl) {
          btn.dataset.nextUrl = newLoadMore.dataset.nextUrl;
          btn.classList.remove('is-loading');
          btn.textContent = 'Show More';
        } else {
          if (loadMoreWrap) loadMoreWrap.remove();
        }
      })
      .catch(function() {
        btn.classList.remove('is-loading');
        btn.textContent = 'Show More';
      });
  });

  /* ---------- Color Swatch — image swap on product card ---------- */
  function updateCardImage(img, src) {
    if (!img || !src) return;
    img.src = src;
    img.setAttribute('src', src);
    img.setAttribute('srcset', src);
  }

  function getProductCardPriceHtml(price, compareAtPrice) {
    var parsedPrice = parseInt(price || '0', 10) || 0;
    var parsedCompareAtPrice = parseInt(compareAtPrice || '0', 10) || 0;

    if (parsedCompareAtPrice > parsedPrice) {
      return '<span class="product-card__price--sale">' + formatMoney(parsedPrice) + '</span><span class="product-card__price--compare">' + formatMoney(parsedCompareAtPrice) + '</span>';
    }

    return formatMoney(parsedPrice);
  }

  function updateProductCardSaleBadge(card, price, compareAtPrice) {
    if (!card) return;

    var badgeStack = card.querySelector('[data-product-card-badge-stack]');
    var discountBadge = card.querySelector('[data-product-card-discount-badge]');
    if (!badgeStack || !discountBadge) return;

    var parsedPrice = parseInt(price || '0', 10) || 0;
    var parsedCompareAtPrice = parseInt(compareAtPrice || '0', 10) || 0;
    var hasDiscount = parsedCompareAtPrice > parsedPrice;

    if (hasDiscount) {
      var discountPercent = Math.round(((parsedCompareAtPrice - parsedPrice) * 100) / parsedCompareAtPrice);
      discountBadge.textContent = discountPercent + '% off';
      discountBadge.classList.remove('hidden');
    } else {
      discountBadge.classList.add('hidden');
    }

    var hasVisibleBadge = Array.prototype.some.call(badgeStack.children, function(child) {
      return !child.classList.contains('hidden');
    });
    badgeStack.classList.toggle('hidden', !hasVisibleBadge);
  }

  function getCartLineDiscountsHtml(discountAllocations) {
    if (!Array.isArray(discountAllocations) || !discountAllocations.length) return '';

    var rows = discountAllocations.map(function(allocation) {
      var application = allocation.discount_application || {};
      var title = application.title || allocation.title || 'Discount';
      var amount = parseInt(allocation.amount || '0', 10) || 0;
      if (amount <= 0) return '';

      return '<span class="cart-item__discount">' + escapeHtml(title) + ' -' + formatMoney(amount) + '</span>';
    }).filter(Boolean).join('');

    return rows ? '<span class="cart-item__discounts" aria-label="Applied discounts">' + rows + '</span>' : '';
  }

  function getCartLevelDiscountApplications(cart) {
    if (!cart) return [];
    if (Array.isArray(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.length) {
      return cart.cart_level_discount_applications;
    }
    if (Array.isArray(cart.discount_applications) && cart.discount_applications.length) {
      return cart.discount_applications.filter(function(application) {
        var targetType = String(application.target_type || application.targetType || '').toLowerCase();
        return !targetType || targetType === 'line_item' || targetType === 'lineitem' || targetType === 'all';
      });
    }
    if (parseInt(cart.total_discount || '0', 10) > 0) {
      return [{ title: 'Discount', total_allocated_amount: cart.total_discount }];
    }
    return [];
  }

  function getCartLevelDiscountAmount(application, cart) {
    var amount = parseInt(
      application.total_allocated_amount ||
      application.total_allocated_amount_set ||
      application.amount ||
      '0',
      10
    ) || 0;

    if (amount <= 0 && cart && cart.total_discount) {
      amount = parseInt(cart.total_discount || '0', 10) || 0;
    }

    return amount;
  }

  function renderCartLevelDiscounts(container, cart) {
    if (!container) return;

    var applications = getCartLevelDiscountApplications(cart);
    var rows = applications.map(function(application) {
      var title = application.title || application.code || 'Discount';
      var amount = getCartLevelDiscountAmount(application, cart);
      if (amount <= 0) return '';

      return '<p class="' + (container.id === 'CartDrawerDiscounts' ? 'cart-drawer__discount' : 'cart-totals__discount') + '">' +
        '<span>' + escapeHtml(title) + '</span>' +
        '<span>-' + formatMoney(amount) + '</span>' +
      '</p>';
    }).filter(Boolean).join('');

    container.innerHTML = rows;
    container.classList.toggle('hidden', !rows);
  }

  function getCartLinePriceHtml(linePrice, unitCompareAtPrice, quantity, unitPrice, originalLinePrice, discountAllocations) {
    var parsedLinePrice = parseInt(linePrice || '0', 10) || 0;
    var parsedUnitCompareAtPrice = parseInt(unitCompareAtPrice || '0', 10) || 0;
    var parsedQuantity = parseInt(quantity || '0', 10) || 0;
    var parsedUnitPrice = parseInt(unitPrice || '0', 10) || 0;
    var parsedOriginalLinePrice = parseInt(originalLinePrice || '0', 10) || 0;
    var discountHtml = getCartLineDiscountsHtml(discountAllocations);

    if (parsedOriginalLinePrice > parsedLinePrice) {
      return '<span class="cart-item__price-current">' + formatMoney(parsedLinePrice) + '</span><span class="product-card__price--compare">' + formatMoney(parsedOriginalLinePrice) + '</span>' + discountHtml;
    }

    if (parsedUnitCompareAtPrice > parsedUnitPrice && parsedQuantity > 0) {
      return '<span class="cart-item__price-current">' + formatMoney(parsedLinePrice) + '</span><span class="product-card__price--compare">' + formatMoney(parsedUnitCompareAtPrice * parsedQuantity) + '</span>' + discountHtml;
    }

    return '<span class="cart-item__price-current">' + formatMoney(parsedLinePrice) + '</span>' + discountHtml;
  }

  function applyProductCardSwatch(swatch) {
    if (!swatch) return;

    var card = swatch.closest('.product-card');
    if (!card) return;

    var primaryImg = card.querySelector('.product-card__img--primary') || card.querySelector('.product-card__media-link img:not(.product-card__img--hover)');
    var hoverImg = card.querySelector('.product-card__img--hover');
    var mediaLink = card.querySelector('.product-card__media-link');
    var titleLink = card.querySelector('.product-card__info a');
    var colorLabel = card.querySelector('[data-product-card-color]');
    var priceLabel = card.querySelector('.product-card__price');
    var wishlistToggle = card.querySelector('[data-wishlist-toggle]');
    var quickAddButton = card.querySelector('[data-quick-add-trigger]');

    var primarySrc = swatch.dataset.variantPrimaryImg || swatch.dataset.variantImg;
    var hoverSrc = swatch.dataset.variantHoverImg || primarySrc;
    var variantUrl = swatch.dataset.variantUrl;
    var variantColor = swatch.dataset.variantColor;

    card.querySelectorAll('.product-card__swatch').forEach(function(currentSwatch) {
      currentSwatch.classList.remove('is-active');
    });
    swatch.classList.add('is-active');

    updateCardImage(primaryImg, primarySrc);
    if (hoverImg) updateCardImage(hoverImg, hoverSrc);
    if (mediaLink && variantUrl) mediaLink.href = variantUrl;
    if (titleLink && variantUrl) titleLink.href = variantUrl;
    if (colorLabel && variantColor) colorLabel.textContent = variantColor;
    if (priceLabel) {
      priceLabel.innerHTML = getProductCardPriceHtml(
        swatch.dataset.variantPrice,
        swatch.dataset.variantCompareAtPrice
      );
    }
    updateProductCardSaleBadge(card, swatch.dataset.variantPrice, swatch.dataset.variantCompareAtPrice);
    updateWishlistToggleDataset(wishlistToggle, {
      wishlistVariantId: swatch.dataset.variantId || '',
      wishlistProductUrl: variantUrl || mediaLink && mediaLink.href || '',
      wishlistVariantTitle: swatch.dataset.variantTitle || '',
      wishlistPrice: swatch.dataset.variantPrice || '',
      wishlistCompareAtPrice: swatch.dataset.variantCompareAtPrice || '',
      wishlistFeaturedImage: primarySrc || '',
      wishlistColor: swatch.dataset.variantColor || '',
      wishlistSize: swatch.dataset.variantSize || '',
      wishlistAvailable: swatch.dataset.variantAvailable || 'false',
      wishlistSelectedOptions: swatch.dataset.variantSelectedOptions || '[]'
    });
    updateProductCardQuickAddDataset(quickAddButton, {
      quickAddProductUrl: variantUrl || mediaLink && mediaLink.href || '',
      quickAddVariantTitle: swatch.dataset.variantTitle || '',
      quickAddPrice: swatch.dataset.variantPrice || '',
      quickAddCompareAtPrice: swatch.dataset.variantCompareAtPrice || '',
      quickAddFeaturedImage: primarySrc || '',
      quickAddColor: swatch.dataset.variantColor || '',
      quickAddVariantId: swatch.dataset.variantId || '',
      quickAddAvailable: swatch.dataset.variantAvailable || 'false',
      quickAddSelectedOptions: swatch.dataset.variantSelectedOptions || '[]'
    });
  }

  function syncProductCardsToActiveCollectionColor(root) {
    var activeColorValue = '';
    var activeColorSwatch = document.querySelector('.filter-section__body--colors .filter-swatch--active');

    if (activeColorSwatch) {
      activeColorValue = activeColorSwatch.dataset.colorValue || '';
    }

    activeColorValue = normalizeColorFilterValue(activeColorValue);
    if (!activeColorValue) return;

    (root || document).querySelectorAll('.product-card').forEach(function(card) {
      var matchingSwatch = Array.prototype.find.call(
        card.querySelectorAll('.product-card__swatch'),
        function(swatch) {
          return normalizeColorFilterValue(swatch.dataset.variantColor) === activeColorValue;
        }
      );

      if (matchingSwatch) {
        applyProductCardSwatch(matchingSwatch);
      }
    });
  }

  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.product-card__swatch');
    if (!swatch) return;
    e.preventDefault();

    applyProductCardSwatch(swatch);
  });

  document.addEventListener('change', function(e) {
    var sizeSelect = e.target.closest('[data-wishlist-size-select]');
    if (!sizeSelect) return;

    var wishlistKey = sizeSelect.dataset.wishlistKey;
    if (!wishlistKey) return;

    wishlistSelections[wishlistKey] = sizeSelect.value || '';
    publishWishlistUpdate();
  });

  function updateGetTheLookItemColor(itemKey, nextColor) {
    if (!getTheLookActiveGroup || !itemKey) return;
    getTheLookActiveGroup.items = getTheLookActiveGroup.items.map(function(item) {
      if (!item || String(item.wishlist_key) !== String(itemKey)) return item;
      if (!item.has_color_option || item.color_option_index === null) return item;

      item.color = nextColor;
      item.selected_options[item.color_option_index] = nextColor;

      if (item.has_selector_option || item.has_size_option) {
        var availableSizes = getWishlistSizeOptions(item).map(function(option) {
          return option.value;
        });
        if (!availableSizes.length || availableSizes.indexOf(item.selected_size) === -1) {
          item.selected_size = '';
        }
      } else {
        var resolvedVariant = getWishlistResolvedVariant(item);
        if (resolvedVariant) {
          item.variant_id = resolvedVariant.id;
          item.available = !!resolvedVariant.available;
        }
      }

      return item;
    });

    refreshGetTheLookOverlayItem(itemKey);
  }

  document.addEventListener('change', function(e) {
    var sizeSelect = e.target.closest('[data-get-the-look-size-select]');
    if (!sizeSelect || !getTheLookActiveGroup) return;
  });

  document.addEventListener('click', function(e) {
    var getTheLookColorSwatch = e.target.closest('[data-get-the-look-color-swatch]');
    if (getTheLookColorSwatch && getTheLookActiveGroup) {
      e.preventDefault();
      updateGetTheLookItemColor(getTheLookColorSwatch.dataset.itemKey, getTheLookColorSwatch.dataset.colorValue || '');
      return;
    }

    var getTheLookSizeOption = e.target.closest('[data-get-the-look-size-option]');
    if (getTheLookSizeOption && getTheLookActiveGroup) {
      e.preventDefault();
      if (getTheLookSizeOption.disabled) return;

      var sizeItemKey = getTheLookSizeOption.dataset.itemKey;
      var nextSelectedSize = getTheLookSizeOption.dataset.sizeValue || '';
      if (!sizeItemKey) return;

      var selections = getTheLookSelectionsForGroup(getTheLookActiveGroup.id);
      selections[sizeItemKey] = nextSelectedSize;

      getTheLookActiveGroup.items = getTheLookActiveGroup.items.map(function(item) {
        if (!item || String(item.wishlist_key) !== String(sizeItemKey)) return item;
        item.selected_size = nextSelectedSize;
        return item;
      });

      refreshGetTheLookOverlayItem(sizeItemKey);
      return;
    }

    var getTheLookOverlayClose = e.target.closest('[data-get-the-look-overlay-close]');
    if (getTheLookOverlayClose) {
      e.preventDefault();
      closeGetTheLookOverlay();
      return;
    }

    var getTheLookAddButton = e.target.closest('[data-get-the-look-add]');
    if (getTheLookAddButton) {
      e.preventDefault();
      if (getTheLookAddButton.disabled) return;
      submitGetTheLookAdd(getTheLookAddButton.dataset.itemKey, getTheLookAddButton);
      return;
    }

    var getTheLookTrigger = e.target.closest('[data-get-the-look-trigger]');
    if (getTheLookTrigger) {
      e.preventDefault();
      if (getTheLookOverlay && getTheLookOverlay.classList.contains('is-open') && getTheLookActiveTrigger === getTheLookTrigger) {
        closeGetTheLookOverlay();
      } else {
        openGetTheLookOverlay(getTheLookTrigger);
      }
      return;
    }

    var quickAddOverlayClose = e.target.closest('[data-quick-add-overlay-close]');
    if (quickAddOverlayClose) {
      e.preventDefault();
      closeQuickAddOverlay();
      return;
    }

    var quickAddSizeButton = e.target.closest('[data-quick-add-overlay-size]');
    if (quickAddSizeButton) {
      e.preventDefault();
      if (quickAddSizeButton.disabled) return;
      var quickAddTrigger = quickAddActiveButton;
      var selectedVariantId = parseWishlistInt(quickAddSizeButton.dataset.variantId);
      var selectedVariant = quickAddTrigger ? getProductCardQuickAddVariantById(quickAddTrigger, selectedVariantId) : null;
      if (!quickAddTrigger || !selectedVariantId || !selectedVariant || !selectedVariant.available) return;
      var quickAddProperties = null;
      var selectedQuickAddData = getProductCardQuickAddData(quickAddTrigger);
      if (selectedQuickAddData && selectedQuickAddData.requiresTournamentFields) {
        quickAddProperties = getQuickAddTournamentPropertiesFromOverlay();
        if (quickAddProperties === false) return;
      }

      submitProductCardQuickAdd(quickAddTrigger, selectedVariantId, selectedVariant, quickAddSizeButton, quickAddProperties);
      return;
    }

    var quickAddSubmitButton = e.target.closest('[data-quick-add-overlay-submit]');
    if (quickAddSubmitButton) {
      e.preventDefault();
      if (quickAddSubmitButton.disabled) return;
      var activeQuickAddTrigger = quickAddActiveButton;
      var activeQuickAddData = getProductCardQuickAddData(activeQuickAddTrigger);
      if (!activeQuickAddTrigger || !activeQuickAddData) return;
      var activeVariant = getProductCardQuickAddVariantById(activeQuickAddTrigger, activeQuickAddData.variantId);
      if (!activeVariant || !activeVariant.available) return;
      var activeProperties = activeQuickAddData.requiresTournamentFields ? getQuickAddTournamentPropertiesFromOverlay() : null;
      if (activeProperties === false) return;

      submitProductCardQuickAdd(activeQuickAddTrigger, activeQuickAddData.variantId, activeVariant, null, activeProperties);
      return;
    }

    var quickAddTrigger = e.target.closest('[data-quick-add-trigger]');
    if (quickAddTrigger) {
      e.preventDefault();
      if (quickAddTrigger.disabled) return;

      var quickAddData = getProductCardQuickAddData(quickAddTrigger);
      var quickAddCard = quickAddTrigger.closest('.product-card');
      if (!quickAddData || !quickAddCard) return;

      if (quickAddData.hasSizeOption || quickAddData.requiresTournamentFields) {
        if (quickAddOverlay && quickAddOverlay.classList.contains('is-open') && quickAddActiveButton === quickAddTrigger) {
          closeQuickAddOverlay();
        } else {
          openQuickAddOverlay(quickAddTrigger);
        }
        return;
      }

      var resolvedVariant = getProductCardQuickAddVariantById(quickAddTrigger, quickAddData.variantId);
      if (!resolvedVariant || !resolvedVariant.available) {
        syncProductCardQuickAdd(quickAddCard);
        return;
      }

      submitProductCardQuickAdd(quickAddTrigger, quickAddData.variantId, resolvedVariant);
      return;
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && getTheLookOverlay && getTheLookOverlay.classList.contains('is-open')) {
      closeGetTheLookOverlay();
      return;
    }

    if (e.key === 'Escape' && quickAddOverlay && quickAddOverlay.classList.contains('is-open')) {
      closeQuickAddOverlay();
    }
  });

  document.addEventListener('click', function(e) {
    var wishlistToggle = e.target.closest('[data-wishlist-toggle]');
    if (wishlistToggle) {
      e.preventDefault();
      toggleWishlistItemFromButton(wishlistToggle, {
        showCartDrawerPopup: !!wishlistToggle.closest('.cart-drawer'),
        showBrowseToast: !wishlistToggle.closest('.cart-drawer') && !wishlistToggle.hasAttribute('data-wishlist-product-page-toggle'),
        showProductPageToast: wishlistToggle.hasAttribute('data-wishlist-product-page-toggle')
      });
      return;
    }

    var copyProductLinkBtn = e.target.closest('[data-copy-product-link]');
    if (copyProductLinkBtn) {
      e.preventDefault();
      var copyUrl = copyProductLinkBtn.dataset.copyUrl;
      if (!copyUrl) return;

      var absoluteUrl;
      try {
        absoluteUrl = new URL(copyUrl, window.location.origin).toString();
      } catch (error) {
        absoluteUrl = copyUrl;
      }

      copyTextToClipboard(absoluteUrl)
        .then(function() {
          setCopyLinkButtonState(copyProductLinkBtn, true);
          showProductPageWishlistToast(productStrings.linkCopied);
          announceCartUpdate(productStrings.linkCopied);
          window.clearTimeout(copyProductLinkBtn._copyResetTimeout);
          copyProductLinkBtn._copyResetTimeout = window.setTimeout(function() {
            setCopyLinkButtonState(copyProductLinkBtn, false);
          }, 1800);
        })
        .catch(function() {
          setCopyLinkButtonState(copyProductLinkBtn, false);
        });
      return;
    }

    var removeBtn = e.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      e.preventDefault();
      var isWishlistDrawerRemove = !!removeBtn.closest('[data-wishlist-drawer]');
      var isWishlistPageRemove = !!removeBtn.closest('[data-wishlist-page]');
      setHeaderWishlistIndicatorVisible(false);
      var removedWishlistItem = removeWishlistItem(removeBtn.dataset.wishlistRemove);
      if (isWishlistDrawerRemove) {
        showCartDrawerWishlistPopup('Item removed from your wishlist');
      } else if (isWishlistPageRemove) {
        lastRemovedWishlistItem = removedWishlistItem;
        showWishlistPageToast('Item removed from your wishlist', { showUndo: !!removedWishlistItem });
      }
      return;
    }

    var addBtn = e.target.closest('[data-wishlist-add]');
    if (addBtn) {
      e.preventDefault();
      if (addBtn.disabled) return;
      var variantId = parseInt(addBtn.dataset.variantId, 10);
      if (!variantId) return;
      var wishlistCard = addBtn.closest('[data-wishlist-card]');
      var wishlistItem = getWishlistItemByKey(addBtn.dataset.wishlistKey);
      var resolvedVariant = wishlistItem ? getWishlistResolvedVariant(wishlistItem) : null;
      var wishlistProperties = getWishlistTournamentPropertiesFromCard(wishlistCard, wishlistItem);
      if (wishlistProperties === false) return;

      setWishlistAddButtonState(addBtn, wishlistStrings.addToBag, true, true, false);
      Promise.all([
        refreshCartQuantities(),
        resolveWishlistVariantInventoryMeta(wishlistItem, resolvedVariant, variantId)
      ])
      .then(function(results) {
        var cart = results[0];
        var inventoryMeta = results[1];
        var inventoryGuard = getCartInventoryGuardResult(variantId, inventoryMeta);
        if (inventoryGuard.blocked) {
          setWishlistAddButtonState(addBtn, wishlistStrings.addToBag, false, false, false);
          handleMaxInventoryReached(variantId);
          return null;
        }

        return addWishlistVariantToCart(variantId, cart, wishlistProperties);
      })
      .then(function(result) {
        if (!result) return;
        if (!result.ok) {
          if (isInventoryLimitErrorResponse(result.data)) {
            setWishlistAddButtonState(addBtn, wishlistStrings.addToBag, false, false, false);
            handleMaxInventoryReached(variantId);
            return;
          }
          setWishlistAddButtonState(addBtn, wishlistStrings.soldOut, true, false, false);
          return;
        }
        if (result.data && Array.isArray(result.data.items)) {
          syncCartQuantitiesFromCart(result.data);
          var updatedItemMatch = getCartItemByVariant(result.data, variantId, wishlistProperties);
          if (!updatedItemMatch || updatedItemMatch.item.quantity < result.expectedQuantity) {
            setWishlistAddButtonState(addBtn, wishlistStrings.addToBag, false, false, false);
            handleMaxInventoryReached(variantId);
            return;
          }
        }
        setWishlistAddButtonState(addBtn, wishlistStrings.added, false, false, true);
        setTimeout(function() {
          fetchAndRenderCart();
          openCartDrawer('bag');
        }, WISHLIST_ADD_SUCCESS_PREVIEW_MS);
        setTimeout(function() {
          setWishlistAddButtonState(addBtn, wishlistStrings.addToBag, false, false, false);
        }, WISHLIST_ADD_SUCCESS_RESET_MS);
      })
      .catch(function() {
        setWishlistAddButtonState(addBtn, wishlistStrings.addToBag, false, false, false);
      });
    }

  });

  document.addEventListener('input', function(e) {
    var propertyInput = e.target.closest('[data-wishlist-property-input]');
    if (!propertyInput) return;

    var propertyWishlistKey = propertyInput.dataset.wishlistKey;
    var propertyFieldKey = propertyInput.dataset.wishlistPropertyKey;
    if (!propertyWishlistKey || !propertyFieldKey) return;

    var updates = {};
    updates[propertyFieldKey] = propertyInput.value || '';
    updateWishlistItemFields(propertyWishlistKey, updates, false);
  });

  window.addEventListener('storage', function(event) {
    if (event.key === WISHLIST_STORAGE_KEY) {
      publishWishlistUpdate();
    }
  });

  function hideProductRecommendations(section) {
    if (!section) return;
    section.classList.remove('is-loading');
    section.setAttribute('aria-hidden', 'true');
    section.dataset.loaded = 'true';
  }

  function mountProductRecommendations(section, nextSection) {
    if (!section || !nextSection) {
      hideProductRecommendations(section);
      return;
    }

    var nextRoot = nextSection.querySelector('[data-product-recommendations-root]');
    var nextCards = nextSection.querySelectorAll('.product-card');
    var currentRoot = section.querySelector('[data-product-recommendations-root]');
    if (!nextRoot || !nextCards.length || !currentRoot) {
      hideProductRecommendations(section);
      return;
    }

    currentRoot.innerHTML = nextRoot.innerHTML;
    section.classList.remove('is-loading');
    section.setAttribute('aria-hidden', 'false');
    section.dataset.loaded = 'true';
    initializeProductCardQuickAdd(currentRoot);
    syncProductCardsToActiveCollectionColor(currentRoot);
  }

  function fetchProductRecommendations(section) {
    if (!section || section.dataset.loading === 'true' || section.dataset.loaded === 'true') return;

    var url = section.dataset.url;
    if (!url) {
      hideProductRecommendations(section);
      return;
    }

    section.dataset.loading = 'true';

    fetch(url)
      .then(function(response) {
        if (!response.ok) throw new Error('Unable to load product recommendations');
        return response.text();
      })
      .then(function(markup) {
        var parser = new DOMParser();
        var recommendationDocument = parser.parseFromString(markup, 'text/html');
        var nextSection = recommendationDocument.querySelector('[data-product-recommendations-section]');
        mountProductRecommendations(section, nextSection);
      })
      .catch(function() {
        hideProductRecommendations(section);
      })
      .then(function() {
        delete section.dataset.loading;
      });
  }

  function initializeProductRecommendations(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = Array.from(scope.querySelectorAll('[data-product-recommendations-section]'));
    if (!sections.length) return;
    sections.forEach(fetchProductRecommendations);
  }

  function initializeInstagramSlideshows(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    var sections = Array.from(scope.querySelectorAll('[data-instagram-slideshow]'));
    if (scope.matches && scope.matches('[data-instagram-slideshow]')) {
      sections.unshift(scope);
    }

    sections.forEach(function(section) {
      if (section.dataset.instagramSlideshowInitialized === 'true') return;

      var viewport = section.querySelector('[data-instagram-slideshow-viewport]');
      var track = section.querySelector('.instagram-slideshow__track');
      var slides = Array.from(section.querySelectorAll('.instagram-slideshow__slide'));
      if (!viewport || !track || slides.length <= 1) return;

      section.dataset.instagramSlideshowInitialized = 'true';

      var intervalSpeed = parseInt(section.dataset.instagramSlideshowSpeed, 10);
      if (isNaN(intervalSpeed)) intervalSpeed = 6000;
      intervalSpeed = Math.max(3000, intervalSpeed);
      var lastTimestamp = null;
      var loopStart = 0;
      var loopEnd = 0;
      var loopWidth = 0;
      var pixelsPerMillisecond = 0;
      var originalSlideCount = slides.length;
      var isUserInteracting = false;
      var originalSlides = slides.slice();

      function cloneSlide(slide) {
        var clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        return clone;
      }

      originalSlides.slice().reverse().forEach(function(slide) {
        track.insertBefore(cloneSlide(slide), track.firstChild);
      });

      originalSlides.forEach(function(slide) {
        var clone = cloneSlide(slide);
        track.appendChild(clone);
      });

      function updateScrollMetrics() {
        slides = Array.from(track.querySelectorAll('.instagram-slideshow__slide')).slice(originalSlideCount, originalSlideCount * 2);
        loopStart = track.children[originalSlideCount] ? track.children[originalSlideCount].offsetLeft : 0;
        loopEnd = track.children[originalSlideCount * 2] ? track.children[originalSlideCount * 2].offsetLeft : 0;
        loopWidth = loopEnd - loopStart;
        pixelsPerMillisecond = getStepSize() / intervalSpeed;
        normalizeScrollPosition();
      }

      function getStepSize() {
        if (slides.length < 2) return slides[0].offsetWidth;
        return slides[1].offsetLeft - slides[0].offsetLeft;
      }

      function scrollContinuously(timestamp) {
        if (!lastTimestamp) lastTimestamp = timestamp;

        if (isUserInteracting) {
          normalizeScrollPosition();
          lastTimestamp = timestamp;
          window.requestAnimationFrame(scrollContinuously);
          return;
        }

        var elapsed = timestamp - lastTimestamp;
        lastTimestamp = timestamp;

        if (loopWidth > 0 && pixelsPerMillisecond > 0) {
          viewport.scrollLeft += elapsed * pixelsPerMillisecond;
          normalizeScrollPosition();
        }

        window.requestAnimationFrame(scrollContinuously);
      }

      function normalizeScrollPosition() {
        if (loopWidth <= 0) return;

        if (viewport.scrollLeft < loopStart) {
          viewport.scrollLeft += loopWidth;
        } else if (viewport.scrollLeft >= loopEnd) {
          viewport.scrollLeft -= loopWidth;
        }
      }

      function pauseAutoScroll() {
        isUserInteracting = true;
        lastTimestamp = null;
      }

      function resumeAutoScroll() {
        isUserInteracting = false;
        lastTimestamp = null;
      }

      window.addEventListener('resize', updateScrollMetrics);
      viewport.addEventListener('scroll', normalizeScrollPosition, { passive: true });
      viewport.addEventListener('touchstart', pauseAutoScroll, { passive: true });
      viewport.addEventListener('touchmove', pauseAutoScroll, { passive: true });
      viewport.addEventListener('touchend', resumeAutoScroll, { passive: true });
      viewport.addEventListener('touchcancel', resumeAutoScroll, { passive: true });

      window.setTimeout(function() {
        updateScrollMetrics();
        viewport.scrollLeft = loopStart;
        window.requestAnimationFrame(scrollContinuously);
      }, 300);
    });
  }

  document.addEventListener('shopify:section:load', function(event) {
    initializeInstagramSlideshows(event.target);
  });

  document.addEventListener('wishlist:updated', function(event) {
    var items = event.detail.items || [];
    renderWishlistPage(items);
    renderWishlistDrawer(items);
    updateCartWishlistIndicators(items);
  });

  document.addEventListener('wishlist:refresh-toggles', function(event) {
    var root = event.detail && event.detail.root;
    refreshWishlistToggles(root, applyWishlistSelections(loadWishlist()));
  });

  /* ---------- Judge.me Copy ---------- */
  (function() {
    var reviewCountPattern = /^(\d+)\s+reviews?$/i;
    var numericRatingPattern = /^\d+(?:\.\d+)?$/;
    var reviewItemRatingPattern = /^(\d+(?:\.\d+)?)\s+out of\s+\d+\s+stars?$/i;

    function clampRating(value) {
      if (isNaN(value)) return 0;
      return Math.max(0, Math.min(5, value));
    }

    function getAverageRatingNodes(cluster) {
      return Array.prototype.filter.call(cluster.children || [], function(node) {
        return node.classList && node.classList.contains('jm-text');
      });
    }

    function updateJudgeMeAverageStars(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var clusters = scope.querySelectorAll('.jm-average-rating-display .jm-cluster');

      clusters.forEach(function(cluster) {
        var textNodes = getAverageRatingNodes(cluster);
        var ratingNode = textNodes[0];
        if (!ratingNode) return;

        var ratingText = (ratingNode.textContent || '').trim();
        if (!numericRatingPattern.test(ratingText)) return;

        var ratingValue = clampRating(parseFloat(ratingText));
        var primaryRow = cluster.querySelector('.jm-average-rating-display__primary');
        if (!primaryRow) {
          primaryRow = document.createElement('div');
          primaryRow.className = 'jm-average-rating-display__primary';
          cluster.insertBefore(primaryRow, ratingNode);
        }

        if (ratingNode.parentNode !== primaryRow) {
          primaryRow.appendChild(ratingNode);
        }

        var stars = primaryRow.querySelector('.jm-average-rating-display__stars');
        if (!stars) {
          stars = document.createElement('span');
          stars.className = 'jm-average-rating-display__stars';
          stars.setAttribute('aria-hidden', 'true');
          primaryRow.appendChild(stars);
        }

        stars.style.setProperty('--rating-fill', ((ratingValue / 5) * 100).toFixed(2) + '%');
      });
    }

    function updateJudgeMeSummaryCopy(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var reviewCountNodes = scope.querySelectorAll('.jm-average-rating-display .jm-cluster > .jm-text:last-of-type');

      reviewCountNodes.forEach(function(node) {
        var text = (node.textContent || '').trim();
        var match = text.match(reviewCountPattern);
        if (!match) return;

        var reviewCount = match[1];
        var reviewLabel = reviewCount === '1' ? 'review' : 'reviews';
        var updatedText = 'Based on ' + reviewCount + ' ' + reviewLabel;

        if (text !== updatedText) {
          node.textContent = updatedText;
        }
      });
    }

    function updateJudgeMeHistogramLabels(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var histogramRows = scope.querySelectorAll('.jm-review-widget-sidebar-header__star-rating-histogram .jm-histogram-row');

      histogramRows.forEach(function(row) {
        var ratingNode = row.querySelector('.jm-histogram-row__rating');
        var frequencyNode = row.querySelector('.jm-histogram-row__frequency');
        if (!ratingNode || !frequencyNode) return;

        var ratingText = (ratingNode.textContent || '').trim();
        var frequencyText = (frequencyNode.textContent || '').trim();
        if (!ratingText || !frequencyText) return;

        var updatedLabel = ratingText.replace(/\s*\(\d+\)\s*$/, '') + ' (' + frequencyText + ')';
        if (ratingNode.textContent !== updatedLabel) {
          ratingNode.textContent = updatedLabel;
        }
      });
    }

    function updateJudgeMeReviewItemRatings(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var reviewStars = scope.querySelectorAll('.jm-review-item .jm-star-rating[aria-label]');

      reviewStars.forEach(function(starsNode) {
        var labelMatch = ((starsNode.getAttribute('aria-label') || '').trim()).match(reviewItemRatingPattern);
        if (!labelMatch) return;

        var ratingText = labelMatch[1];
        var cluster = starsNode.querySelector('.jm-cluster');
        if (!cluster) return;

        var existingSiblingLabel = starsNode.parentNode ? starsNode.parentNode.querySelector('.jm-review-item__rating-label') : null;
        if (existingSiblingLabel) {
          existingSiblingLabel.remove();
        }

        var ratingLabel = cluster.querySelector('.jm-review-item__rating-label');
        if (!ratingLabel) {
          ratingLabel = document.createElement('span');
          ratingLabel.className = 'jm-review-item__rating-label';
          cluster.insertBefore(ratingLabel, cluster.firstChild);
        }

        ratingLabel.textContent = ratingText;
      });
    }

    function refreshJudgeMeSummary(root) {
      updateJudgeMeAverageStars(root);
      updateJudgeMeSummaryCopy(root);
      updateJudgeMeHistogramLabels(root);
      updateJudgeMeReviewItemRatings(root);
    }

    refreshJudgeMeSummary(document);

    if (!document.body || typeof MutationObserver === 'undefined') return;

    var judgeMeObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (!(node instanceof Element)) return;

          if (
            node.matches('.jm-average-rating-display, .jm-review-widget-sidebar-header__star-rating-histogram, .jm-review-item') ||
            node.querySelector('.jm-average-rating-display, .jm-review-widget-sidebar-header__star-rating-histogram, .jm-review-item')
          ) {
            refreshJudgeMeSummary(node);
          }
        });
      });
    });

    judgeMeObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();

  publishWishlistUpdate();
  initializeProductRecommendations(document);
  initializeInstagramSlideshows(document);
  initializeProductCardQuickAdd(document);
  syncProductCardsToActiveCollectionColor(document);
  renderWishlistPage(loadWishlist());
  renderWishlistDrawer(loadWishlist());

})();
